
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jv3O2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");

const $a23dc1f066cda204$var$i18nBase = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle",
        defaultMessage: "This page was switched to a live page"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle",
        defaultMessage: "You\u2019ve switched to a live page"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody",
        defaultMessage: "Updates to this page will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore",
        defaultMessage: "Find out more"
    },
    reloadButton: {
        id: "editor-flags.convert-to-live-page-flag.reloadButton",
        defaultMessage: "Reload"
    }
});
const $a23dc1f066cda204$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle.livedocs",
        defaultMessage: "This page was converted to a live doc"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle.livedocs",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody.livedocs",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore.livedocs",
        defaultMessage: "Find out more about live docs"
    }
});
const $a23dc1f066cda204$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($a23dc1f066cda204$var$i18nBase, $a23dc1f066cda204$var$i18nLiveDocs);
const $a23dc1f066cda204$var$LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME = 11000;
const $a23dc1f066cda204$export$cb5a789d90de377 = ({ flags: flags })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const intl = (0, $kSwu1.useIntl)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const handleOnClick = (0, $cozmU.useCallback)(()=>{
        const livePageLink = (0, $1NBp8.VIEW_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        });
        return isOnEditRoute ? replace(livePageLink) : window.location.reload();
    }, [
        isOnEditRoute,
        replace,
        spaceKey,
        contentId
    ]);
    return (0, $cozmU.useCallback)(async ({ converterWasCurrentUser: converterWasCurrentUser })=>{
        const successFlag = await flags.showFlag({
            title: converterWasCurrentUser ? intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.switcherFlagTitle) : intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagTitle),
            description: intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagBody),
            type: 'success',
            id: 'convert-to-live-page-flag',
            close: 'never',
            // Needed to bypass the flags.hideAllFlags() call in EditorFlags.tsx on editor unmount.
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                        "data-testid": "reload-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.reloadButton)),
                    onClick: handleOnClick
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                        "data-testid": "find-out-more-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.findOutMore)),
                    onClick: ()=>window.open($a23dc1f066cda204$var$LEARN_MORE_URL, '_blank')
                }
            ]
        });
        // We don't want to auto-close the flag when a different user converts the page,
        // because there's no auto-redirect, so the user must click "Reload" in the flag to continue.
        if (converterWasCurrentUser) // Manually set a timeout so the flag auto-closes after the page transition completes.
        setTimeout(()=>flags.hideFlag(successFlag.id), $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME);
    }, [
        intl,
        flags,
        handleOnClick
    ]);
};
module.exports["useShowConvertToLivePageFlag"] = $a23dc1f066cda204$export$cb5a789d90de377;

});

parcelRegister("dLX9a", function(module, exports) {

var $cb6fO = parcelRequire("cb6fO");


var $cEgMD = parcelRequire("cEgMD");


var $1NBp8 = parcelRequire("1NBp8");


var $dqLea = parcelRequire("dqLea");

const $89342ddee4389e57$export$9d5b76aa7bb3f492 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return (0, $1NBp8.COMPANY_HUB).toUrl();
    const path = `${(0, $cb6fO.getSpaceLink)(spaceKey, contentType === 'page' ? 'pages' : 'blog')}/${contentId}`;
    return path;
};
const $89342ddee4389e57$export$5906c3344719ad0e = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, breadcrumbs: breadcrumbs, isUnpublishedDraft: isUnpublishedDraft })=>{
    let url = (0, $1NBp8.HOME).toUrl();
    if (isUnpublishedDraft) {
        if (contentType === 'page') // Draft page -> redirect to closest published parent view page
        {
            if (breadcrumbs) {
                url = (0, $dqLea.getNearestVisibleAncestor)({
                    breadcrumbs: breadcrumbs,
                    fallbackUrl: url
                });
                // if the parent is a folder, redirect to the space overview
                if ((0, $1NBp8.FOLDER_VIEW).match(url)) url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                    spaceKey: spaceKey
                });
            }
        } else // Draft blog -> redirect to space index page
        url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
    } else // this part executes when closing the edit section for a previously/already published page
    // we can do a lil hack here to avoid making a query.
    // the router will prettify our route with slug (& posting date for blogs) for us
    url = $89342ddee4389e57$export$9d5b76aa7bb3f492({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    return url;
};
module.exports["getPublishPreloadUrl"] = $89342ddee4389e57$export$9d5b76aa7bb3f492;
module.exports["getClosePreloadUrl"] = $89342ddee4389e57$export$5906c3344719ad0e;

});

parcelRegister("dqLea", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab = ({ breadcrumbs: breadcrumbs, fallbackUrl: fallbackUrl })=>{
    let url = fallbackUrl;
    // Loop through all breadcrumbs from bottom up and find the first view page url
    if (breadcrumbs) for(let index = breadcrumbs.length - 1; index >= 0; index--){
        const crumb = breadcrumbs[index];
        const ancestorUrl = crumb?.url;
        if (ancestorUrl && !(0, $1NBp8.RESUME_DRAFT_LEGACY).match(ancestorUrl)) {
            url = ancestorUrl;
            break;
        }
    }
    return url;
};
module.exports["getNearestVisibleAncestor"] = $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab;

});

parcelRegister("8G1o2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8WndG = parcelRequire("8WndG");


var $eitcW = parcelRequire("eitcW");

function $4afe25e74c0897d4$export$af6ae8f81a672789(contentId) {
    const { data: data, error: error } = (0, $eitcW.useExperimentalEditorBreadcrumbsQuery)({
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    return (0, $cozmU.useMemo)(()=>{
        return (0, $8WndG.handleEditorBreadcrumbsQueryResult)(data, error);
    }, [
        data,
        error
    ]);
}
module.exports["useEditorBreadcrumbs"] = $4afe25e74c0897d4$export$af6ae8f81a672789;

});

parcelRegister("8WndG", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");

function $808c5ea5e28dcdc3$export$ba755fc0ebb98c2(data, error) {
    if (error) {
        if ((0, $6fil2.containsNetworkError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }
    return data?.experimentalEditorBreadcrumbs?.breadcrumbs || [];
}
module.exports["handleEditorBreadcrumbsQueryResult"] = $808c5ea5e28dcdc3$export$ba755fc0ebb98c2;

});

parcelRegister("eitcW", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d = ({ variables: variables, skip: skip, onError: onError })=>{
    const { contentId: contentId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/pages/breadcrumb.action?pageId=${contentId}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (json, _variables)=>{
            if (!contentId) throw new Error('contentId is missing.');
            return {
                experimentalEditorBreadcrumbs: {
                    breadcrumbs: json?.breadcrumbs || null
                }
            };
        },
        skip: skip,
        variables: variables,
        onError: onError
    });
};
module.exports["useExperimentalEditorBreadcrumbsQuery"] = $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d;

});

parcelRegister("18vK6", function(module, exports) {

var $6ZtPk = parcelRequire("6ZtPk");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $jMyy4 = parcelRequire("jMyy4");


var $kfIha = parcelRequire("kfIha");


var $1RN2b = parcelRequire("1RN2b");

const $c8a2a643eaa1809a$var$useCopyContentLinkCopyLinkQuery = (0, $6ZtPk.default);
var $c8a2a643eaa1809a$export$61634440d18842d5 = /*#__PURE__*/ function(SUPPORTED_CONTENT_TYPES) {
    SUPPORTED_CONTENT_TYPES["PAGE"] = "page";
    SUPPORTED_CONTENT_TYPES["BLOGPOST"] = "blogpost";
    SUPPORTED_CONTENT_TYPES["OVERVIEW"] = "overview";
    SUPPORTED_CONTENT_TYPES["WHITEBOARD"] = "whiteboard";
    SUPPORTED_CONTENT_TYPES["EMBED"] = "embed";
    SUPPORTED_CONTENT_TYPES["DATABASE"] = "database";
    return SUPPORTED_CONTENT_TYPES;
}({});
const $c8a2a643eaa1809a$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $cozmU.useState)();
    const { toUrl: toUrl } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($c8a2a643eaa1809a$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "share-and-restrict-dialog"
    });
    const getCopyContentLink = (0, $cozmU.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === (0, $1RN2b.PAGE_MODE).EDIT) copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) return `${links.base}${copyLink}`;
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === (0, $1RN2b.PAGE_MODE).EDIT) {
            routeName = contentType === "blogpost" ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === "blogpost" ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case "overview":
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case "blogpost":
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case "page":
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case "whiteboard":
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case "embed":
                routeName = (0, $1NBp8.EMBED_VIEW).name;
                break;
            case "database":
                routeName = (0, $1NBp8.DATABASE_VIEW).name;
                break;
            // omit unsupported content types
            default:
                if (!contentType) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $1RN2b.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'copied',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $1RN2b.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            return `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $cozmU.useCallback)(()=>{
        return copyToClipboard(getCopyContentLink());
    }, [
        getCopyContentLink,
        copyToClipboard
    ]);
    return (0, $cozmU.useMemo)(()=>({
            queryError: queryError,
            unsupportedLinkError: unsupportedLinkError,
            getCopyContentLink: getCopyContentLink,
            copyContentLink: copyContentLink
        }), [
        queryError,
        unsupportedLinkError,
        getCopyContentLink,
        copyContentLink
    ]);
};
module.exports["SUPPORTED_CONTENT_TYPES"] = $c8a2a643eaa1809a$export$61634440d18842d5;
module.exports["useCopyContentLink"] = $c8a2a643eaa1809a$export$a049904f049cf16d;

});

parcelRegister("6ZtPk", function(module, exports) {
/**
 * @generated SignedSource<<eb2b56a2caf0d743247e79708ebe7cd0>>
 * @relayHash 18ff4f8d8b4085f53eca6f5430f839ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59
const $833a147e3ae344d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkCopyLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkCopyLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "18ff4f8d8b4085f53eca6f5430f839ae",
            "id": "696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59",
            "metadata": {},
            "name": "useCopyContentLinkCopyLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$833a147e3ae344d9$var$node.hash = "d21c9891b99750e37c7d31e767baec64";
var $833a147e3ae344d9$export$2e2bcd8739ae039 = $833a147e3ae344d9$var$node;
module.exports["default"] = $833a147e3ae344d9$export$2e2bcd8739ae039;

});

parcelRegister("1RN2b", function(module, exports) {
const $d453ec9fb76ba7fd$export$9957974f8b4d8f74 = 'copyShareLink';
var $d453ec9fb76ba7fd$export$e82cf716cce37b4e = /*#__PURE__*/ function(PAGE_MODE) {
    PAGE_MODE["VIEW"] = "view";
    PAGE_MODE["EDIT"] = "edit";
    return PAGE_MODE;
}({});
module.exports["ACTION_SUBJECT_ID"] = $d453ec9fb76ba7fd$export$9957974f8b4d8f74;
module.exports["PAGE_MODE"] = $d453ec9fb76ba7fd$export$e82cf716cce37b4e;

});

parcelRegister("jroIa", function(module, exports) {
/**
 * @generated SignedSource<<8e1cc591f1435412c119051736e0078a>>
 * @relayHash 985f6ee79c133e444ec409d517228f1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871
const $fe9e027b65465b8b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "currentUserIsWatching"
                },
                {
                    "kind": "ScalarField",
                    "name": "currentUserIsWatchingChildren"
                },
                {
                    "kind": "ScalarField",
                    "name": "currentUserHasAncestorWatchingChildren"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatchingBlogs"
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "985f6ee79c133e444ec409d517228f1d",
            "id": "6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871",
            "metadata": {},
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "operationKind": "query",
            "text": "query WatchDialogComponentWithWatchChildrenQuery($contentId:ID!){singleContent(id:$contentId){__typename,id,currentUserIsWatching,currentUserIsWatchingChildren,currentUserHasAncestorWatchingChildren,type,space{id,key,currentUser{isWatched,isWatchingBlogs},operations{operation,targetType}}}}"
        }
    };
}();
$fe9e027b65465b8b$var$node.hash = "b5ae30f67304ac91f4e47cad0c3cbfda";
var $fe9e027b65465b8b$export$2e2bcd8739ae039 = $fe9e027b65465b8b$var$node;
module.exports["default"] = $fe9e027b65465b8b$export$2e2bcd8739ae039;

});

parcelRegister("6KaG6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ce38ba3becf24406$export$877a45ed8043e865 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9Gzp",
    name: "ObjectSidebarPanel",
    loader: async ()=>(await (parcelRequire("1McpR"))).ObjectSidebarPanelWrapper
});
module.exports["ObjectSidebarPanel"] = $ce38ba3becf24406$export$877a45ed8043e865;

});

parcelRegister("1McpR", function(module, exports) {

let $14b3e7b71ed2faef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $14b3e7b71ed2faef$var$load("35Mi3"),
    $14b3e7b71ed2faef$var$load("g9l6t"),
    $14b3e7b71ed2faef$var$load("7wlV6"),
    $14b3e7b71ed2faef$var$load("gpF3C"),
    $14b3e7b71ed2faef$var$load("hhss7"),
    $14b3e7b71ed2faef$var$load("gr9Xf")
]).then(()=>parcelRequire('iFpSu'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("g1WP0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a55d612ff94024a3$var$ThirdPartyNudge = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("h7ldz")).then(({ ThirdPartyNudge: ThirdPartyNudge })=>({
            default: ThirdPartyNudge
        })));

const $a55d612ff94024a3$var$NotificationNudge = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("h7ldz")).then(({ NotificationNudge: NotificationNudge })=>({
            default: NotificationNudge
        })));
const $a55d612ff94024a3$export$91e508f993b0fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a55d612ff94024a3$var$ThirdPartyNudge, props));
const $a55d612ff94024a3$export$abc42570cc861f1b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a55d612ff94024a3$var$NotificationNudge, null));
module.exports["AsyncWrapper"] = $a55d612ff94024a3$export$91e508f993b0fdc;

});

parcelRegister("h7ldz", function(module, exports) {

let $c7638c8f4609be46$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c7638c8f4609be46$var$load("lrXQY"),
    $c7638c8f4609be46$var$load("6wr18"),
    $c7638c8f4609be46$var$load("ffEVr"),
    $c7638c8f4609be46$var$load("7EorR"),
    $c7638c8f4609be46$var$load("ea3NB"),
    $c7638c8f4609be46$var$load("hhss7"),
    $c7638c8f4609be46$var$load("bCr24")
]).then(()=>parcelRequire('arPKr'));

});

parcelRegister("i5zxs", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $jVylI = parcelRequire("jVylI");

class $e6a27c260ce1aef4$export$edf095fb7f09a5c0 extends (0, $kNIYN.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            hasCoverPicture: false,
            isUploadingPicture: false,
            isModalOpen: false,
            isRemovingPicture: false,
            isRepositioningPicture: false,
            isAddHeaderImageButtonFocused: false,
            coverPictureId: '',
            shouldShowReposition: false,
            isChangingPicture: false,
            coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            shouldShowAIImageAcceptanceFlow: false,
            lastAIGenerationParams: null,
            isCurrentAIFCAutoImage: false
        };
        this.setHasCoverPicture = (hasCoverPicture)=>this.setState({
                hasCoverPicture: hasCoverPicture
            });
        this.toggleCoverPictureWidthButton = (coverPictureWidth)=>this.setState({
                coverPictureWidth: coverPictureWidth
            });
        this.setCoverPictureId = (coverPictureId)=>this.setState({
                coverPictureId: coverPictureId
            });
        this.setIsUploadingPicture = (isUploadingPicture)=>this.setState({
                isUploadingPicture: isUploadingPicture
            });
        this.setIsModalOpen = (isModalOpen)=>this.setState({
                isModalOpen: isModalOpen
            });
        this.setIsChangingPicture = (isChangingPicture)=>this.setState({
                isChangingPicture: isChangingPicture
            });
        this.setIsRemovingPicture = (isRemovingPicture)=>this.setState({
                isRemovingPicture: isRemovingPicture
            });
        this.setIsRepositioningPicture = (isRepositioningPicture)=>this.setState({
                isRepositioningPicture: isRepositioningPicture
            });
        this.setShouldShowReposition = (shouldShowReposition)=>this.setState({
                shouldShowReposition: shouldShowReposition
            });
        this.setIsAddHeaderImageButtonFocused = (isAddHeaderImageButtonFocused)=>this.setState({
                isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused
            });
        this.setShouldShowAIImageAcceptanceFlow = (shouldShowAIImageAcceptanceFlow)=>this.setState({
                shouldShowAIImageAcceptanceFlow: shouldShowAIImageAcceptanceFlow
            });
        this.setLastAIGenerationParams = (lastAIGenerationParams)=>this.setState({
                lastAIGenerationParams: lastAIGenerationParams
            });
        this.setIsCurrentAIFCAutoImage = (isCurrentAIFCAutoImage)=>this.setState({
                isCurrentAIFCAutoImage: isCurrentAIFCAutoImage
            });
        this.resetToDefaults = ()=>{
            this.setIsModalOpen(false);
            this.setIsAddHeaderImageButtonFocused(false);
            this.setIsUploadingPicture(false);
            this.setIsChangingPicture(false);
            this.setIsRemovingPicture(false);
            this.setShouldShowReposition(false);
            this.toggleCoverPictureWidthButton((0, $jVylI.COVERPICTUREWIDTH).FULL);
            this.setShouldShowAIImageAcceptanceFlow(false);
            this.setLastAIGenerationParams(null);
            this.setIsCurrentAIFCAutoImage(false);
        };
    }
}
module.exports["CoverPictureStateContainer"] = $e6a27c260ce1aef4$export$edf095fb7f09a5c0;

});

parcelRegister("Qlykt", function(module, exports) {
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;
module.exports["EMOJI_SIZE_MEDIUM"] = $f866e8db934ec558$export$d7240ab6bd9deaf0;
module.exports["EMOJI_SIZE_LARGE"] = $f866e8db934ec558$export$7d383c70a74caba8;

});

parcelRegister("1B6Lx", function(module, exports) {

var $hm7Pp = parcelRequire("hm7Pp");


var $fgrom = parcelRequire("fgrom");


var $1dRHU = parcelRequire("1dRHU");


var $ej7SU = parcelRequire("ej7SU");


var $cozmU = parcelRequire("cozmU");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");








var $ep3mz = parcelRequire("ep3mz");


var $de2j9 = parcelRequire("de2j9");

const $42cdb37fcd4a7f68$export$751dd0cb1bbd0638 = ()=>{
    const readLastEditedDraftVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ej7SU.default),
        __callerPackage__: "content-types-utils"
    });
    const readLastEditedVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $1dRHU.default),
        __callerPackage__: "content-types-utils"
    });
    const writeLastEditedDraftVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $fgrom.default),
        fragmentArtifact: (0, $fgrom.default),
        __callerPackage__: "content-types-utils"
    });
    const writeLastEditedVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $hm7Pp.default),
        fragmentArtifact: (0, $hm7Pp.default),
        __callerPackage__: "content-types-utils"
    });
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [currentPageContentId] = (0, $ep3mz.usePageContentId)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const updateTimestampCache = ({ contentId: contentId })=>{
        const newWhen = new Date().toISOString();
        const isEditingThisContent = isOnEditRoute && contentId === currentPageContentId;
        const id = `$Content:${contentId}.${isEditingThisContent ? 'draftVersion' : 'version'}`;
        let prevTypename = 'KnownUser';
        try {
            const readFragmentInterop = isEditingThisContent ? readLastEditedDraftVersionFragmentFragmentInterop : readLastEditedVersionFragmentFragmentInterop;
            const prevCache = readFragmentInterop({
                id: id
            });
            if (prevCache?.by?.__typename) prevTypename = prevCache.by.__typename;
        } catch  {
        // silently fallback to default typename "KnownUser"
        }
        try {
            const writeFragmentInterop = isEditingThisContent ? writeLastEditedDraftVersionFragmentFragmentInterop : writeLastEditedVersionFragmentFragmentInterop;
            writeFragmentInterop({
                fragmentId: id,
                data: {
                    by: {
                        displayName: displayName,
                        __typename: prevTypename
                    },
                    when: newWhen,
                    __typename: 'Version'
                }
            });
        } catch  {
        // silently fail write to cache
        }
    };
    const updateTimestampCacheWithCallback = (0, $cozmU.useCallback)(updateTimestampCache, [
        currentPageContentId,
        isOnEditRoute,
        displayName,
        readLastEditedDraftVersionFragmentFragmentInterop,
        readLastEditedVersionFragmentFragmentInterop,
        writeLastEditedDraftVersionFragmentFragmentInterop,
        writeLastEditedVersionFragmentFragmentInterop
    ]);
    return updateTimestampCacheWithCallback;
};
module.exports["useUpdateLastEditedTimestampVersionCache"] = $42cdb37fcd4a7f68$export$751dd0cb1bbd0638;

});

parcelRegister("hm7Pp", function(module, exports) {
/**
 * @generated SignedSource<<4c861bd06806240d51e12f7f085d0825>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03557d594dff4afc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$03557d594dff4afc$var$node.hash = "c18ed3f2e877d3ca1cd623e5a0859ba4";
var $03557d594dff4afc$export$2e2bcd8739ae039 = $03557d594dff4afc$var$node;
module.exports["default"] = $03557d594dff4afc$export$2e2bcd8739ae039;

});

parcelRegister("fgrom", function(module, exports) {
/**
 * @generated SignedSource<<80c5c7a474f99fd1ce0dcfa37ed63a6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61389ca52d0a73e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$61389ca52d0a73e1$var$node.hash = "f2546d473e081d7f407ad1cb2c10a7c2";
var $61389ca52d0a73e1$export$2e2bcd8739ae039 = $61389ca52d0a73e1$var$node;
module.exports["default"] = $61389ca52d0a73e1$export$2e2bcd8739ae039;

});

parcelRegister("1dRHU", function(module, exports) {
/**
 * @generated SignedSource<<9c87c26246d4536040dd79e5c847aea5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $342531e247c7cf4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$342531e247c7cf4b$var$node.hash = "e1d2099945c80fbb0be34791a561397b";
var $342531e247c7cf4b$export$2e2bcd8739ae039 = $342531e247c7cf4b$var$node;
module.exports["default"] = $342531e247c7cf4b$export$2e2bcd8739ae039;

});

parcelRegister("ej7SU", function(module, exports) {
/**
 * @generated SignedSource<<56e47737c7339d2b755b2c7c5677fdf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4982d7036fccc1ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$4982d7036fccc1ba$var$node.hash = "52ad41feb7c48850dc9ff2da1dd55879";
var $4982d7036fccc1ba$export$2e2bcd8739ae039 = $4982d7036fccc1ba$var$node;
module.exports["default"] = $4982d7036fccc1ba$export$2e2bcd8739ae039;

});

parcelRegister("gw4Bt", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $08e48bbb9421afc0$export$8fdec53caa79133c;

});

parcelRegister("6DT7W", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8e77e8dd4ed98ba0$export$8e100eba08cca59e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "C9H24",
    name: "RequestAccessPopupComponent",
    loader: async ()=>(await (parcelRequire("3Oija"))).RequestAccessPopupComponent
});
module.exports["RequestAccessPopupComponent"] = $8e77e8dd4ed98ba0$export$8e100eba08cca59e;

});

parcelRegister("3Oija", function(module, exports) {

let $2c643e358e42e420$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c643e358e42e420$var$load("lk4cE").then(()=>parcelRequire('1hgMC'));

});

parcelRegister("grWYF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $8lt1a = parcelRequire("8lt1a");


var $dPJCf = parcelRequire("dPJCf");


var $lsxnT = parcelRequire("lsxnT");


var $fdPUP = parcelRequire("fdPUP");

const $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('journeyId');
function $3a4ed6f24f1b06e9$export$715107a573a5fba6(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { onClose: onClose, journeyId: journeyId } = t0;
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== journeyId) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingPagePermissionsSpotlight",
                    attributes: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        journeyId: journeyId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            journeyId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = journeyId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.ok",
            defaultMessage: "Ok"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClose) {
        t4 = [
            {
                onClick: onClose,
                text: t3
            }
        ];
        $[5] = onClose;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.body",
            defaultMessage: "Control who can view, edit, and comment on your pages."
        });
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== Spotlight || $[9] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            actions: t4,
            target: "share-button-spotlight-target",
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "bottom right",
            dialogWidth: 275,
            messageType: "transactional"
        }, t5);
        $[8] = Spotlight;
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
function $3a4ed6f24f1b06e9$export$31f46f470e475335() {
    const $ = (0, $bDgLe.c)(10);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const journeyId = $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    const hasRun = (0, $cozmU.useRef)(false);
    const [cachedJourneyId, setCachedJourneyId] = (0, $cozmU.useState)();
    let t0;
    let t1;
    if ($[0] !== journeyId || $[1] !== setQueryParams) {
        t0 = ()=>{
            if (hasRun.current) return;
            hasRun.current = true;
            if (journeyId !== "onboarding-page-permissions") return;
            setCachedJourneyId(journeyId);
            setQueryParams({
                journeyId: null
            });
            setIsSpotlightActive(true);
        };
        t1 = [
            journeyId,
            setQueryParams
        ];
        $[0] = journeyId;
        $[1] = setQueryParams;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsSpotlightActive(false);
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClose = t2;
    let t3;
    if ($[5] !== cachedJourneyId || $[6] !== isSpotlightActive) {
        t3 = isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3a4ed6f24f1b06e9$export$715107a573a5fba6, {
            onClose: handleOnClose,
            journeyId: cachedJourneyId
        });
        $[5] = cachedJourneyId;
        $[6] = isSpotlightActive;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
}
module.exports["OnboardingPagePermissionsSpotlight"] = $3a4ed6f24f1b06e9$export$715107a573a5fba6;
module.exports["OnboardingPagePermissionsSpotlightLoader"] = $3a4ed6f24f1b06e9$export$31f46f470e475335;

});

parcelRegister("cf6nm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e = ({ isStarred: isStarred, spacing: spacing = 'spacious' })=>{
    const theme = (0, $IQ4Dz.default)();
    const starredColor = theme.colorMode === 'dark' ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
        label: "",
        color: starredColor,
        spacing: spacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
        label: "",
        color: "currentColor",
        spacing: spacing
    });
};
module.exports["StarIcon"] = $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e;

});

parcelRegister("77a1U", function(module, exports) {

var $4GiSr = parcelRequire("4GiSr");


var $9fsLe = parcelRequire("9fsLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7aRa9 = parcelRequire("7aRa9");


var $308Wd = parcelRequire("308Wd");


var $cfidN = parcelRequire("cfidN");

const $280d5b858bf30a19$var$PageStarActionButtonPageStarMutation = (0, $9fsLe.default);
const $280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation = (0, $4GiSr.default);
const $280d5b858bf30a19$var$i18n = (0, $kSwu1.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.content.star.error.title",
        defaultMessage: "We\u2019re having trouble starring this"
    },
    unstarErrorTitle: {
        id: "action-buttons.content.unstar.error.title",
        defaultMessage: "We\u2019re having trouble unstarring this"
    },
    starSuccessFlagTitle: {
        id: "action-buttons.content.star.success.title",
        defaultMessage: "{contentTitle} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.content.unstar.success.title",
        defaultMessage: "{contentTitle} unstarred"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh the page and try again."
    }
});
const $280d5b858bf30a19$var$useStarAnalytics = (contentId, analytics)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const stringAttrs = JSON.stringify(analytics?.attributes);
    return (0, $cozmU.useCallback)((action)=>{
        if (!analytics) return;
        const { source: source, containerId: containerId, attributes: attributes } = analytics;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'favouritePage',
                source: source,
                attributes: attributes,
                objectId: contentId,
                ...containerId && {
                    containerId: containerId
                }
            }
        }).fire();
    }, // Using stringAttrs as dependency instead of analytics.attributes
    // https://github.com/facebook/react/issues/14476
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        createAnalyticsEvent,
        analytics?.source,
        stringAttrs
    ]);
};
const $280d5b858bf30a19$var$PageStarComponent = ({ contentId: contentId, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, contentTitle: contentTitle = '', shouldShowFlags: shouldShowFlags = false })=>{
    const sendAnalyticsEvent = $280d5b858bf30a19$var$useStarAnalytics(contentId, analytics);
    const [star, { error: starError }] = (0, $308Wd.useMutationInterop)($280d5b858bf30a19$var$PageStarActionButtonPageStarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('created');
        },
        optimisticResponse: {
            favouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: {
                                __typename: 'FavouritedSummary',
                                isFavourite: true,
                                favouritedDate: new Date().toISOString()
                            }
                        }
                    }
                }
            }
        },
        __callerPackage__: "action-buttons"
    });
    const [unstar, { error: unstarError }] = (0, $308Wd.useMutationInterop)($280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('deleted');
        },
        optimisticResponse: {
            unfavouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: null
                        }
                    }
                }
            }
        },
        __callerPackage__: "action-buttons"
    });
    const toggleStar = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) {
            onUnstar && onUnstar(e);
            unstar().then(()=>{
                if (shouldShowFlags) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        } else {
            onStar && onStar(e);
            star().then(()=>{
                if (shouldShowFlags) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.starSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        }
    }, [
        isStarred,
        onStar,
        star,
        onUnstar,
        unstar,
        contentTitle,
        flags,
        intl,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.starErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $280d5b858bf30a19$export$110ac8adb8c8c03 = (0, $7aRa9.withFlags)((0, $kSwu1.injectIntl)($280d5b858bf30a19$var$PageStarComponent));
module.exports["PageStar"] = $280d5b858bf30a19$export$110ac8adb8c8c03;

});

parcelRegister("4GiSr", function(module, exports) {
/**
 * @generated SignedSource<<3ffaffb5926ed36d9f66867563c732ed>>
 * @relayHash d1da572c7c92b4b266a94268aa3424c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5938f592be4f9ebb2a4b0128e9ff6974fda1a9904b1cf83b7ff9a9ab5cf46b5
const $dc0ccf8bb0c1b893$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "unfavouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageStarActionButtonPageUnstarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageStarActionButtonPageUnstarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d1da572c7c92b4b266a94268aa3424c4",
            "id": "e5938f592be4f9ebb2a4b0128e9ff6974fda1a9904b1cf83b7ff9a9ab5cf46b5",
            "metadata": {},
            "name": "PageStarActionButtonPageUnstarMutation",
            "operationKind": "mutation",
            "text": "mutation PageStarActionButtonPageUnstarMutation($id:ID!){unfavouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite,favouritedDate}}}}}}"
        }
    };
}();
$dc0ccf8bb0c1b893$var$node.hash = "a57f208826520a57e991955e40d84900";
var $dc0ccf8bb0c1b893$export$2e2bcd8739ae039 = $dc0ccf8bb0c1b893$var$node;
module.exports["default"] = $dc0ccf8bb0c1b893$export$2e2bcd8739ae039;

});

parcelRegister("9fsLe", function(module, exports) {
/**
 * @generated SignedSource<<7f76fd0bae1e7b61d1546ce4fc192079>>
 * @relayHash 893e4cc7292e06a05c8e163bfde7c2d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000
const $6cc5c6f8cf8165a3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "favouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageStarActionButtonPageStarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageStarActionButtonPageStarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "893e4cc7292e06a05c8e163bfde7c2d8",
            "id": "e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000",
            "metadata": {},
            "name": "PageStarActionButtonPageStarMutation",
            "operationKind": "mutation",
            "text": "mutation PageStarActionButtonPageStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite,favouritedDate}}}}}}"
        }
    };
}();
$6cc5c6f8cf8165a3$var$node.hash = "2fe8e2e773241c74a33b1336ab2db2b2";
var $6cc5c6f8cf8165a3$export$2e2bcd8739ae039 = $6cc5c6f8cf8165a3$var$node;
module.exports["default"] = $6cc5c6f8cf8165a3$export$2e2bcd8739ae039;

});

parcelRegister("cfidN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7aRa9 = parcelRequire("7aRa9");


var $b3j2Y = parcelRequire("b3j2Y");

const $774441f3315c6f72$export$5b6a77363c518c1c = (0, $7aRa9.withFlags)(({ flags: flags, title: title, description: description, error: error })=>{
    (0, $cozmU.useEffect)(()=>{
        flags.showErrorFlag({
            id: 'action-button-error',
            title: title,
            description: description
        });
    }, [
        title,
        description,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
});
module.exports["ActionErrorFlag"] = $774441f3315c6f72$export$5b6a77363c518c1c;

});

parcelRegister("7d41Y", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("9SsRl", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $730f8b16a3d58539$export$8ce793b178574678 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["WATCH_BUTTON_METRIC"] = $730f8b16a3d58539$export$8ce793b178574678;

});

parcelRegister("gqsYd", function(module, exports) {
const $bf558bf49003e931$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["CONFLUENCE_EDITION"] = $bf558bf49003e931$export$4b915fb24c39b396;

});

parcelRegister("49Q03", function(module, exports) {

var $jroIa = parcelRequire("jroIa");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6b4nE = parcelRequire("6b4nE");

parcelRequire("6SsN4");


var $4n1IT = parcelRequire("4n1IT");


var $9DHhW = parcelRequire("9DHhW");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gqqjz = parcelRequire("gqqjz");


var $lOkIA = parcelRequire("lOkIA");


var $jmjWc = parcelRequire("jmjWc");


var $kvJHJ = parcelRequire("kvJHJ");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $7zgzO = parcelRequire("7zgzO");


var $g1WP0 = parcelRequire("g1WP0");


var $308Wd = parcelRequire("308Wd");


var $20FI0 = parcelRequire("20FI0");


var $9SsRl = parcelRequire("9SsRl");


var $2REhP = parcelRequire("2REhP");


var $jle6C = parcelRequire("jle6C");


var $6in0A = parcelRequire("6in0A");


const $47908050ea4fd9b1$export$9c5737ae30e94007 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "aohZt",
    name: "LazyWatchDialogContent",
    loader: async ()=>(await (parcelRequire("jiSQR"))).WatchDialogContent,
    loading: ({ shouldSSRWatchButton: shouldSSRWatchButton })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                width: '325px',
                height: '180px'
            }
        }, !shouldSSRWatchButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium"
        }))
});

const $47908050ea4fd9b1$var$LazyWatchDialogShortcut = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gDGxN",
    name: "LazyWatchDialogShortcut",
    loader: async ()=>(await (parcelRequire("6Uey7"))).WatchDialogShortcut
});
const $47908050ea4fd9b1$var$i18n = (0, $kSwu1.defineMessages)({
    watchContentDialogLabel: {
        id: "watch-dialog.popup.label",
        defaultMessage: "Watch content dialog"
    }
});
const $47908050ea4fd9b1$export$f521883565cfd8d9 = (0, $jroIa.default);
const $47908050ea4fd9b1$export$4b54507e0234ad87 = (0, $kSwu1.injectIntl)(({ contentId: contentId, spaceId: spaceId, params: params, defaultTab: defaultTab, customPlacement: customPlacement, flagsContainer: flagsContainer, isDisabled: /**
   * This disables the usage of the watch button and dialog.
   *
   * Note: If a `customTrigger` is provided, this will be passed through
   * as `isDisabled`. However, as a fallback, even if the button is not
   * disabled properly, the logic here will continue to be disabled.
   */ isDisabled, customTrigger: customTrigger, useShortcut: useShortcut, shouldSSRWatchButton: shouldSSRWatchButton, skipTrialDetailsQuery: skipTrialDetailsQuery, contentType: contentType, componentLocation: componentLocation, intl: intl })=>{
    const [dialogOpen, setDialogOpen] = (0, $cozmU.useState)(false);
    const [shouldOpenWatchDialogFromQueryParams, setShouldOpenWatchDialogFromQueryParams] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const nudgeRef = (0, $cozmU.useRef)(null);
    const { isWatchingContent: isWatchingContent, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, isWatchingSpace: isWatchingSpace } = params;
    (0, $cozmU.useEffect)(()=>{
        if (isDisabled) return;
        const { openWatchModal: openWatchModal } = getQueryParams();
        setShouldOpenWatchDialogFromQueryParams(openWatchModal === 'true' && (componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).SPACE_OVERVIEW || componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).PAGE));
        if (shouldOpenWatchDialogFromQueryParams) setDialogOpen(true);
    }, [
        isDisabled,
        getQueryParams,
        componentLocation,
        shouldOpenWatchDialogFromQueryParams
    ]);
    const removeOpenModalQueryParams = ()=>{
        const queryParams = getQueryParams();
        if (queryParams.openWatchModal) {
            setQueryParams({
                ...queryParams,
                openWatchModal: undefined
            }, true);
            setShouldOpenWatchDialogFromQueryParams(false);
        }
    };
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        // Do not enable open the dialog if watch is disabled
        if (isDisabled) return;
        setDialogOpen((prevState)=>!prevState);
    }, [
        isDisabled
    ]);
    const isWatching = (0, $cozmU.useCallback)(()=>{
        // If watch is disabled, then the user will default to not watching
        return isDisabled ? false : isWatchingContent || isWatchingSpace || isWatchingChildren || hasAncestorWatchingChildren;
    }, [
        isWatchingContent,
        isWatchingChildren,
        hasAncestorWatchingChildren,
        isWatchingSpace,
        isDisabled
    ]);
    const updateQueryHandler = (updateContentType, newDataValue)=>{
        const contentData = (0, $l1uFv.readQueryInterop)({
            query: $47908050ea4fd9b1$export$f521883565cfd8d9,
            variables: {
                contentId: contentId
            },
            __callerPackage__: "watch-dialog"
        });
        switch(updateContentType){
            case (0, $jle6C.UpdateContentType).CONTENT:
                contentData.singleContent.currentUserIsWatching = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).CHILDREN:
                contentData.singleContent.currentUserIsWatchingChildren = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).SPACE:
                contentData.singleContent.space.currentUser.isWatched = newDataValue;
                break;
            default:
                contentData.singleContent.space.currentUser.isWatchingBlogs = newDataValue;
                break;
        }
        (0, $fEmGS.writeQueryInterop)({
            query: $47908050ea4fd9b1$export$f521883565cfd8d9,
            data: contentData,
            __callerPackage__: "watch-dialog"
        });
    };
    const fireWatchAnalyticsEvent = (0, $cozmU.useCallback)((action, actionSubject)=>{
        const analyticsData = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: contentId,
            objectId: contentId,
            objectType: contentType,
            source: 'WatchButton'
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const [watchContent] = (0, $308Wd.useMutationInterop)((0, $6in0A.default), {
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CONTENT);
            toggleDialog();
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE),
                error: error.message
            });
        },
        update: (_, { data: { watchContent: watchContentData } })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CONTENT, watchContentData.content.currentUserIsWatching);
        },
        __callerPackage__: "watch-dialog"
    });
    const handleOneClickWatch = (0, $cozmU.useCallback)(async ()=>{
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE));
        if (experienceState === null || experienceState.hasStopped) experienceTracker.start({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
        });
        await watchContent({
            variables: {
                id: contentId
            }
        });
    }, [
        watchContent,
        contentId,
        experienceTracker
    ]);
    const handleWatchButtonClick = (0, $cozmU.useCallback)(async ()=>{
        if (dialogOpen || isWatching()) toggleDialog();
        else await handleOneClickWatch();
    }, [
        toggleDialog,
        isWatching,
        dialogOpen,
        handleOneClickWatch
    ]);
    const openDialog = ()=>{
        setDialogOpen(true);
    };
    const closeDialog = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'dialog',
                actionSubjectId: 'watchDialog',
                source: 'WatchDialogContent',
                attributes: {
                    contentType: contentType
                }
            }
        }).fire();
        setDialogOpen(false);
    };
    const renderPopupTrigger = (triggerProps)=>{
        const TriggerButton = customTrigger || (0, $20FI0.WatchButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TriggerButton, {
            isDisabled: isDisabled,
            isWatching: isWatching(),
            isSelected: dialogOpen,
            onMouseOver: $47908050ea4fd9b1$export$9c5737ae30e94007.preload,
            onClick: handleWatchButtonClick,
            triggerProps: triggerProps,
            shouldSSRWatchButton: shouldSSRWatchButton,
            defaultTab: defaultTab,
            contentId: contentId,
            updateQueryHandler: updateQueryHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.CONTENT_TYPES_HEADER_WATCH_EXPERIENCE),
            attributes: {
                isWatching: isWatching()
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
        }));
    };
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"}`
            },
            ref: nudgeRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($47908050ea4fd9b1$export$9c5737ae30e94007, {
            contentId: contentId,
            spaceId: spaceId,
            defaultTab: defaultTab,
            params: params,
            closeWatchDialog: closeDialog,
            updateQueryHandler: updateQueryHandler,
            skipTrialDetailsQuery: skipTrialDetailsQuery,
            contentType: contentType,
            shouldOpenWatchDialogFromQueryParams: shouldOpenWatchDialogFromQueryParams,
            removeOpenModalQueryParams: removeOpenModalQueryParams
        })), dialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g1WP0.AsyncWrapper), {
            trigger: "watch-page",
            showImage: false,
            width: 357,
            reference: nudgeRef
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, useShortcut && !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($47908050ea4fd9b1$var$LazyWatchDialogShortcut, {
        contentId: contentId,
        contentType: contentType,
        params: params,
        flagsContainer: flagsContainer,
        openDialog: openDialog,
        updateQueryHandler: updateQueryHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: dialogOpen,
        onClose: closeDialog,
        content: ()=>renderPopupContent(),
        trigger: renderPopupTrigger,
        placement: customPlacement,
        role: "dialog",
        label: intl.formatMessage($47908050ea4fd9b1$var$i18n.watchContentDialogLabel),
        testId: "watch-content-dialog",
        shouldRenderToParent: true
    }));
});
$47908050ea4fd9b1$export$4b54507e0234ad87.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    spaceId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).shape({
        isWatchingContent: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
        isWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
        hasAncestorWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
        isWatchingSpace: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired
    }).isRequired,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number.isRequired,
    customPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    flagsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).instanceOf((0, $gqqjz.FlagsStateContainer)),
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    customTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).elementType,
    useShortcut: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    shouldSSRWatchButton: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    skipTrialDetailsQuery: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    componentLocation: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
};
module.exports["WatchDialogComponentWithWatchChildrenQuery"] = $47908050ea4fd9b1$export$f521883565cfd8d9;
module.exports["WatchDialogComponent"] = $47908050ea4fd9b1$export$4b54507e0234ad87;

});

parcelRegister("20FI0", function(module, exports) {
/* WatchButton.js generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7ZB0A = parcelRequire("7ZB0A");


var $XgBmC = parcelRequire("XgBmC");


var $a79Sy = parcelRequire("a79Sy");


var $lpNn5 = parcelRequire("lpNn5");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $cMvQV = parcelRequire("cMvQV");

const $176bef54c656e043$var$i18n = (0, $kSwu1.defineMessages)({
    startWatchingIconLabel: {
        id: "watch-dialog.watch-button.start.watching.label",
        defaultMessage: "Start watching"
    },
    stopWatchingIconLabel: {
        id: "watch-dialog.watch-button.stop.watching.label",
        defaultMessage: "Stop watching"
    },
    watchStopTooltip: {
        id: "watch-dialog.stop.button.tooltip",
        defaultMessage: "Stop watching"
    },
    watchStartTooltip: {
        id: "watch-dialog.start.button.tooltip",
        defaultMessage: "Watch"
    }
});
const $176bef54c656e043$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0sElkwuNcX",
            __cmplp.className
        ])
    });
});
const $176bef54c656e043$var$WatchButtonComponent = ({ isDisabled: isDisabled, isWatching: isWatching, isSelected: isSelected, onClick: onClick, onMouseOver: onMouseOver, intl: intl, triggerProps: triggerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const fireClickAnalyticsEvent = (0, $cozmU.useCallback)(()=>{
        const analyticsData = {
            action: 'clicked',
            actionSubject: 'content-watch-button',
            source: 'viewPageScreen'
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleWatchButtonClick = ()=>{
        onClick();
        fireClickAnalyticsEvent();
    };
    const shortcutContent = isWatching ? intl.formatMessage($176bef54c656e043$var$i18n.watchStopTooltip) : intl.formatMessage($176bef54c656e043$var$i18n.watchStartTooltip);
    const getTooltipContent = ()=>{
        if (isDisabled) return undefined;
        if (isLiveEditMode || isOnEditRoute) return shortcutContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT),
            contentBefore: shortcutContent,
            isTooltip: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        content: getTooltipContent()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($176bef54c656e043$export$2d5d2ba3c7c8c40b, {
        "data-id": "page-watch-button",
        "data-test-id": "page-watch-button",
        testId: "page-watch-button",
        appearance: "subtle",
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleWatchButtonClick,
        onMouseOver: onMouseOver,
        onFocus: onMouseOver,
        iconBefore: isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($XgBmC))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.stopWatchingIconLabel),
            testId: "watch-filled-icon",
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.startWatchingIconLabel),
            testId: "watch-icon",
            spacing: "spacious"
        }),
        ...triggerProps
    }));
};
$176bef54c656e043$var$WatchButtonComponent.propTypes = {
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isWatching: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    triggerProps: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
const $176bef54c656e043$export$e149a93a7ac7f896 = (0, $kSwu1.injectIntl)($176bef54c656e043$var$WatchButtonComponent);
module.exports["WatchButton"] = $176bef54c656e043$export$e149a93a7ac7f896;

});

parcelRegister("2REhP", function(module, exports) {
const $215fc810f2773ade$export$613942ed7ac4b968 = {
    PAGE: 0,
    SPACE_OVERVIEW: 1,
    FEED: 2,
    WHITEBOARD: 3
};
module.exports["WATCH_DIALOG_LOCATION"] = $215fc810f2773ade$export$613942ed7ac4b968;

});

parcelRegister("jle6C", function(module, exports) {
var $b11a466056fa4426$export$f8bb0b205e1c369c = /*#__PURE__*/ function(UpdateContentType) {
    UpdateContentType["CONTENT"] = "content";
    UpdateContentType["CHILDREN"] = "children";
    UpdateContentType["BLOGS_IN_SPACE"] = "blogs";
    UpdateContentType["SPACE"] = "space";
    return UpdateContentType;
}({});
var $b11a466056fa4426$export$3b880fb327a46f45 = /*#__PURE__*/ function(UpdateType) {
    UpdateType["WATCH"] = "watch";
    UpdateType["UNWATCH"] = "unwatch";
    return UpdateType;
}({});
module.exports["UpdateContentType"] = $b11a466056fa4426$export$f8bb0b205e1c369c;
module.exports["UpdateType"] = $b11a466056fa4426$export$3b880fb327a46f45;

});

parcelRegister("6in0A", function(module, exports) {
/**
 * @generated SignedSource<<fba01a40abf41f38229c896823374e27>>
 * @relayHash fd81f231087cf7200e9dc6564487d4ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286
const $e1f35a163a9ce341$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "id"
                        },
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchContentInput"
                }
            ],
            "concreteType": "WatchContentPayload",
            "kind": "LinkedField",
            "name": "watchContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "currentUserIsWatching"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchDialogContentWatchContentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchDialogContentWatchContentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fd81f231087cf7200e9dc6564487d4ac",
            "id": "8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286",
            "metadata": {},
            "name": "WatchDialogContentWatchContentMutation",
            "operationKind": "mutation",
            "text": "mutation WatchDialogContentWatchContentMutation($id:ID!){watchContent(watchContentInput:{contentId:$id,currentUser:true}){content{id,currentUserIsWatching}}}"
        }
    };
}();
$e1f35a163a9ce341$var$node.hash = "c3af78be0429c7abdaa087ce8a337162";
var $e1f35a163a9ce341$export$2e2bcd8739ae039 = $e1f35a163a9ce341$var$node;
module.exports["default"] = $e1f35a163a9ce341$export$2e2bcd8739ae039;

});

parcelRegister("jiSQR", function(module, exports) {

let $e0da3f20f1afa4b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e0da3f20f1afa4b6$var$load("dPFEi"),
    $e0da3f20f1afa4b6$var$load("6damH"),
    $e0da3f20f1afa4b6$var$load("kHXvF"),
    $e0da3f20f1afa4b6$var$load("9OSao")
]).then(()=>parcelRequire('jjM3c'));

});

parcelRegister("6Uey7", function(module, exports) {

let $507342388c13d0d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $507342388c13d0d6$var$load("8hbZ5").then(()=>parcelRequire('j00wp'));

});

parcelRegister("f9HtC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0896bd7bf351fc8$export$73075fe16d77da88 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ckcO3",
    name: "ManageWatcherDialogLoader",
    loader: async ()=>(await (parcelRequire("85ZC8"))).ManageWatcherDialog
});
module.exports["ManageWatcherDialogLoader"] = $b0896bd7bf351fc8$export$73075fe16d77da88;

});

parcelRegister("85ZC8", function(module, exports) {

let $5e4e95a70cd6f00e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5e4e95a70cd6f00e$var$load("6wr18"),
    $5e4e95a70cd6f00e$var$load("c831e"),
    $5e4e95a70cd6f00e$var$load("1GCFv"),
    $5e4e95a70cd6f00e$var$load("h4Nf7"),
    $5e4e95a70cd6f00e$var$load("cFgVe"),
    $5e4e95a70cd6f00e$var$load("5wzAc"),
    $5e4e95a70cd6f00e$var$load("ffEVr"),
    $5e4e95a70cd6f00e$var$load("Wowvf"),
    $5e4e95a70cd6f00e$var$load("uvm9i"),
    $5e4e95a70cd6f00e$var$load("7EorR"),
    $5e4e95a70cd6f00e$var$load("hhss7"),
    $5e4e95a70cd6f00e$var$load("iJwzY")
]).then(()=>parcelRequire('45gVm'));

});

parcelRegister("jeQ9x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $3Ttlf = parcelRequire("3Ttlf");


const $476a1a146c5d6cec$export$c41c4f98f15bcd25 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "I7qQB",
    name: "PublishButtonWithMoreOptions",
    loader: async ()=>{
        return (await (parcelRequire("4llKP"))).PublishButtonWithMoreOptions;
    },
    loading: (0, $3Ttlf.PlaceholderPublishButton)
});
module.exports["PublishButtonWithMoreOptions"] = $476a1a146c5d6cec$export$c41c4f98f15bcd25;

});

parcelRegister("3Ttlf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $iV65j = parcelRequire("iV65j");


var $krxYo = parcelRequire("krxYo");


var $lACKt = parcelRequire("lACKt");

const $6d1be32de0860931$export$a6f3e6c7a6e250cc = ({ publishButtonDisabled: publishButtonDisabled, isUnpublishedDraft: isUnpublishedDraft, shouldShowWorldIcon: shouldShowWorldIcon })=>{
    const intl = (0, $kSwu1.useIntl)();
    if (!isUnpublishedDraft) {
        const WorldIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), {
                label: intl.formatMessage((0, $lACKt.i18nShared).updatePublicContentLabel),
                color: "var(--ds-icon-inverse, #FFFFFF)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV65j.SplitButton), {
            appearance: "primary",
            isDisabled: publishButtonDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: publishButtonDisabled,
            iconBefore: shouldShowWorldIcon ? WorldIcon : undefined
        }, intl.formatMessage((0, $lACKt.i18nShared).updateButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $lACKt.i18nShared).chevronButtonTooltipObjectHeader)
        }));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lACKt.i18nShared).publishButton));
};
module.exports["PlaceholderPublishButton"] = $6d1be32de0860931$export$a6f3e6c7a6e250cc;

});

parcelRegister("lACKt", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f823ee887c9ee745$export$54342bba4612eedb = (0, $kSwu1.defineMessages)({
    publishButton: {
        id: "publish-modal.default-publish-button",
        defaultMessage: "Publish..."
    },
    updateButton: {
        id: "publish-modal.update-button",
        defaultMessage: "Update"
    },
    chevronButtonTooltipObjectHeader: {
        id: "publish-modal.split-button-tooltip.object-header",
        defaultMessage: "Update settings"
    },
    updatePublicContentLabel: {
        id: "publish-modal.update-public-content-label",
        defaultMessage: "Update public content"
    }
});
module.exports["i18nShared"] = $f823ee887c9ee745$export$54342bba4612eedb;

});

parcelRegister("4llKP", function(module, exports) {

let $3299ff87aba1f36f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3299ff87aba1f36f$var$load("dPFEi"),
    $3299ff87aba1f36f$var$load("4izLy"),
    $3299ff87aba1f36f$var$load("vsgOr"),
    $3299ff87aba1f36f$var$load("i313S"),
    $3299ff87aba1f36f$var$load("6wr18"),
    $3299ff87aba1f36f$var$load("6HLQW"),
    $3299ff87aba1f36f$var$load("8bdMn"),
    $3299ff87aba1f36f$var$load("j8Ant"),
    $3299ff87aba1f36f$var$load("aP4DK"),
    $3299ff87aba1f36f$var$load("2F69B"),
    $3299ff87aba1f36f$var$load("dgerE"),
    $3299ff87aba1f36f$var$load("7wlV6"),
    $3299ff87aba1f36f$var$load("el56J"),
    $3299ff87aba1f36f$var$load("5zDuS"),
    $3299ff87aba1f36f$var$load("ffEVr"),
    $3299ff87aba1f36f$var$load("7EorR"),
    $3299ff87aba1f36f$var$load("ea3NB"),
    $3299ff87aba1f36f$var$load("9cpj1"),
    $3299ff87aba1f36f$var$load("excC5"),
    $3299ff87aba1f36f$var$load("aLbuU"),
    $3299ff87aba1f36f$var$load("6vqGz"),
    $3299ff87aba1f36f$var$load("hhss7"),
    $3299ff87aba1f36f$var$load("89b92")
]).then(()=>parcelRequire('6cfXd'));

});

parcelRegister("l7iY7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $7Sm4c = parcelRequire("7Sm4c");


var $ivb8S = parcelRequire("ivb8S");


var $fsF73 = parcelRequire("fsF73");

const $508580e8423e2725$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $508580e8423e2725$export$26f6630e61e959f9 = (isUnpublishedDraft)=>{
    const hasSeenPublishSpotlightRef = (0, $cozmU.useRef)(null);
    const showRecap2025QueryParam = $508580e8423e2725$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isUnpublishedDraft;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $fsF73.CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS).HAS_SEEN_PUBLISH_SPOTLIGHT, !isEligible);
    const { hasSeenPublishSpotlight: hasSeenPublishSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    // Mark GraphQL errors as handled since we gracefully treat them as "hasn't seen spotlight"
    (0, $cozmU.useEffect)(()=>{
        if (onboardingStateError) (0, $7Sm4c.markErrorAsHandled)(onboardingStateError);
    }, [
        onboardingStateError
    ]);
    // Capture the value once when it first becomes available
    // This ensures state changes during the current render cycle don't affect eligibility
    if (hasSeenPublishSpotlightRef.current === null && !onboardingStateLoading) hasSeenPublishSpotlightRef.current = hasSeenPublishSpotlight;
    if (onboardingStateLoading || onboardingStateError) return false;
    // If user has already seen the spotlight, don't show it again
    if (Boolean(hasSeenPublishSpotlightRef.current)) return false;
    return isEligible;
};
module.exports["useRecapSpotlightEligibility"] = $508580e8423e2725$export$26f6630e61e959f9;

});

parcelRegister("bHd1w", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f760397570928c6$export$28f6951b4656036e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AuHVu",
    name: "MovePageDialog",
    loader: async ()=>(await (parcelRequire("jUktV"))).MovePageDialog
});
module.exports["MovePageDialog"] = $4f760397570928c6$export$28f6951b4656036e;

});

parcelRegister("jUktV", function(module, exports) {

let $e7e3228a0b968609$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e7e3228a0b968609$var$load("dgerE"),
    $e7e3228a0b968609$var$load("dPFEi"),
    $e7e3228a0b968609$var$load("bfTdl"),
    $e7e3228a0b968609$var$load("2cSY3"),
    $e7e3228a0b968609$var$load("c5pF4"),
    $e7e3228a0b968609$var$load("4evdD"),
    $e7e3228a0b968609$var$load("eNXvp"),
    $e7e3228a0b968609$var$load("d0wSR"),
    $e7e3228a0b968609$var$load("vsgOr"),
    $e7e3228a0b968609$var$load("i313S"),
    $e7e3228a0b968609$var$load("6wr18"),
    $e7e3228a0b968609$var$load("e4XZ1"),
    $e7e3228a0b968609$var$load("4tFwP"),
    $e7e3228a0b968609$var$load("3BNIx"),
    $e7e3228a0b968609$var$load("gbDLp"),
    $e7e3228a0b968609$var$load("1v24l"),
    $e7e3228a0b968609$var$load("204ne"),
    $e7e3228a0b968609$var$load("hBTro"),
    $e7e3228a0b968609$var$load("9pso5"),
    $e7e3228a0b968609$var$load("4fYzp"),
    $e7e3228a0b968609$var$load("1GCFv"),
    $e7e3228a0b968609$var$load("gW7tk"),
    $e7e3228a0b968609$var$load("jzPyj"),
    $e7e3228a0b968609$var$load("f7R6d"),
    $e7e3228a0b968609$var$load("251nM"),
    $e7e3228a0b968609$var$load("5zDuS"),
    $e7e3228a0b968609$var$load("eH9NY"),
    $e7e3228a0b968609$var$load("kHXvF"),
    $e7e3228a0b968609$var$load("ea3NB"),
    $e7e3228a0b968609$var$load("ffEVr"),
    $e7e3228a0b968609$var$load("exBMi"),
    $e7e3228a0b968609$var$load("6vqGz"),
    $e7e3228a0b968609$var$load("iBJWz"),
    $e7e3228a0b968609$var$load("4izLy"),
    $e7e3228a0b968609$var$load("Wowvf"),
    $e7e3228a0b968609$var$load("uvm9i"),
    $e7e3228a0b968609$var$load("9vN6N"),
    $e7e3228a0b968609$var$load("29WXq"),
    $e7e3228a0b968609$var$load("7EorR"),
    $e7e3228a0b968609$var$load("953Uz"),
    $e7e3228a0b968609$var$load("hhss7"),
    $e7e3228a0b968609$var$load("36rXN")
]).then(()=>parcelRequire('4yvcZ'));

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("lYrp8", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $ftFOj = parcelRequire("ftFOj");

const $c3ac8a024e96d385$export$bffe0f7f3be64e87 = (spaceKey, milestone, options = {})=>{
    const { skip: skip = false } = options;
    const { isSmartFoldersEnabled: isSmartFoldersEnabled, loading: loading } = (0, $ftFOj.useIsSmartFoldersEnabled)(skip ? null : spaceKey);
    if (skip) return {
        isSmartFoldersEnabledForMilestone: false,
        loading: false
    };
    // eslint-disable-next-line confluence-feature-gating/inline-usage
    return {
        isSmartFoldersEnabledForMilestone: isSmartFoldersEnabled && (0, $6mKj3.expVal)('confluence_smart_folders_milestone', 'value', 0) >= milestone,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabledForMilestone"] = $c3ac8a024e96d385$export$bffe0f7f3be64e87;

});

parcelRegister("k22lL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1988df8ccc55d194$export$8cf79fbd47bc14c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wym_j",
    name: "ArchiveUpsellDialog",
    loader: async ()=>(await (parcelRequire("h1yHQ"))).ArchiveUpsellDialog
});
module.exports["ArchiveUpsellDialog"] = $1988df8ccc55d194$export$8cf79fbd47bc14c3;

});

parcelRegister("h1yHQ", function(module, exports) {

let $c64d7399e239c6bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c64d7399e239c6bf$var$load("fINdN"),
    $c64d7399e239c6bf$var$load("hOaAV"),
    $c64d7399e239c6bf$var$load("cPaXL")
]).then(()=>parcelRequire('v2hhG'));

});

parcelRegister("2WH1B", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2099f9ed78e06b67$export$baebba9f0bb9158 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ptN9P",
    name: "ArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("lzy9P"))).ArchivePagesLoader
});
module.exports["ArchivePagesLoader"] = $2099f9ed78e06b67$export$baebba9f0bb9158;

});

parcelRegister("lzy9P", function(module, exports) {

let $fb475cd73ec19a69$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fb475cd73ec19a69$var$load("bfTdl"),
    $fb475cd73ec19a69$var$load("2cSY3"),
    $fb475cd73ec19a69$var$load("c5pF4"),
    $fb475cd73ec19a69$var$load("4evdD"),
    $fb475cd73ec19a69$var$load("6wr18"),
    $fb475cd73ec19a69$var$load("dRQ13"),
    $fb475cd73ec19a69$var$load("jyWy1"),
    $fb475cd73ec19a69$var$load("LWh5V"),
    $fb475cd73ec19a69$var$load("ffEVr"),
    $fb475cd73ec19a69$var$load("Wowvf"),
    $fb475cd73ec19a69$var$load("kHXvF"),
    $fb475cd73ec19a69$var$load("iWnyc"),
    $fb475cd73ec19a69$var$load("excC5"),
    $fb475cd73ec19a69$var$load("hhss7"),
    $fb475cd73ec19a69$var$load("3uux1")
]).then(()=>parcelRequire('iYH6z'));

});

parcelRegister("1AbrA", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a94896b24fa6d771$export$833a1d1f1b7e4f0f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "MiFff",
    name: "PageQuickActionAutomationMenu",
    loader: async ()=>(await (parcelRequire("fvGpK"))).PageQuickActionAutomationMenu
});
module.exports["PageQuickActionAutomationMenu"] = $a94896b24fa6d771$export$833a1d1f1b7e4f0f;

});

parcelRegister("fvGpK", function(module, exports) {

let $b4aaa6d8293c14a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b4aaa6d8293c14a0$var$load("3gMot"),
    $b4aaa6d8293c14a0$var$load("vsgOr"),
    $b4aaa6d8293c14a0$var$load("i313S"),
    $b4aaa6d8293c14a0$var$load("1X4na"),
    $b4aaa6d8293c14a0$var$load("4xZ5N"),
    $b4aaa6d8293c14a0$var$load("kHXvF"),
    $b4aaa6d8293c14a0$var$load("iWnyc"),
    $b4aaa6d8293c14a0$var$load("Wowvf"),
    $b4aaa6d8293c14a0$var$load("uvm9i"),
    $b4aaa6d8293c14a0$var$load("7EorR"),
    $b4aaa6d8293c14a0$var$load("hhss7"),
    $b4aaa6d8293c14a0$var$load("9QyoN")
]).then(()=>parcelRequire('bm1ob'));

});

parcelRegister("6ykQV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf5e0ab73c00afb3$export$25f686fb78162d50 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fmQ7C",
    name: "DeleteNestedPagesActionLoader",
    loader: async ()=>(await (parcelRequire("7SMyC"))).DeleteNestedPagesAction
});
module.exports["DeleteNestedPagesActionLoader"] = $cf5e0ab73c00afb3$export$25f686fb78162d50;

});

parcelRegister("7SMyC", function(module, exports) {

let $5bd33e0d0b2dcefe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5bd33e0d0b2dcefe$var$load("dPFEi"),
    $5bd33e0d0b2dcefe$var$load("iWnyc"),
    $5bd33e0d0b2dcefe$var$load("bfTdl"),
    $5bd33e0d0b2dcefe$var$load("2cSY3"),
    $5bd33e0d0b2dcefe$var$load("6wr18"),
    $5bd33e0d0b2dcefe$var$load("33ouG"),
    $5bd33e0d0b2dcefe$var$load("73HOd"),
    $5bd33e0d0b2dcefe$var$load("LWh5V"),
    $5bd33e0d0b2dcefe$var$load("Wowvf"),
    $5bd33e0d0b2dcefe$var$load("kHXvF"),
    $5bd33e0d0b2dcefe$var$load("excC5"),
    $5bd33e0d0b2dcefe$var$load("ffEVr"),
    $5bd33e0d0b2dcefe$var$load("hhss7"),
    $5bd33e0d0b2dcefe$var$load("9YGIy")
]).then(()=>parcelRequire('9R4ZE'));

});

parcelRegister("5FwhF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ee4e9cc4db58f73d$export$b3f442789ed34bf1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MHkm",
    name: "CopyPageTreeDialog",
    loader: async ()=>(await (parcelRequire("baQol"))).CopyPageTreeContainer
});
module.exports["CopyPageTreeDialog"] = $ee4e9cc4db58f73d$export$b3f442789ed34bf1;

});

parcelRegister("baQol", function(module, exports) {

let $822944c32fa2b861$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $822944c32fa2b861$var$load("bfTdl"),
    $822944c32fa2b861$var$load("2cSY3"),
    $822944c32fa2b861$var$load("vsgOr"),
    $822944c32fa2b861$var$load("i313S"),
    $822944c32fa2b861$var$load("6wr18"),
    $822944c32fa2b861$var$load("4tFwP"),
    $822944c32fa2b861$var$load("3BNIx"),
    $822944c32fa2b861$var$load("hBTro"),
    $822944c32fa2b861$var$load("9pso5"),
    $822944c32fa2b861$var$load("251nM"),
    $822944c32fa2b861$var$load("eH9NY"),
    $822944c32fa2b861$var$load("ffEVr"),
    $822944c32fa2b861$var$load("kHXvF"),
    $822944c32fa2b861$var$load("iWnyc"),
    $822944c32fa2b861$var$load("excC5"),
    $822944c32fa2b861$var$load("7EorR"),
    $822944c32fa2b861$var$load("Wowvf"),
    $822944c32fa2b861$var$load("uvm9i"),
    $822944c32fa2b861$var$load("hhss7"),
    $822944c32fa2b861$var$load("p4ay7")
]).then(()=>parcelRequire('c7g9a'));

});

parcelRegister("5wA2k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5qRqQ = parcelRequire("5qRqQ");

const $db92b1048ab2b69e$var$SMART_FOLDER_PROPERTIES_KEY = 'smartFolderProperties';
const $db92b1048ab2b69e$var$DEFAULT_PROVIDER = (0, $5qRqQ.SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS)['google-drive'];
const $db92b1048ab2b69e$var$normalizeProviderName = (name)=>name.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
const $db92b1048ab2b69e$var$providerByContainerApp = {
    [$db92b1048ab2b69e$var$normalizeProviderName('Google Drive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('google-drive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('google-drive-connector')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-gdrive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-gdrive-rsl')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('lite-connector-gdrive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('SharePoint')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('sharepoint')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('sharepoint-connector')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-sharepoint')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('ai-3p-connector:sharepoint-domain')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('OneDrive')]: 'onedrive',
    [$db92b1048ab2b69e$var$normalizeProviderName('onedrive')]: 'onedrive',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-onedrive')]: 'onedrive',
    [$db92b1048ab2b69e$var$normalizeProviderName('onedrive-connector')]: 'onedrive'
};
const $db92b1048ab2b69e$var$rememberedSources = new Map();
const $db92b1048ab2b69e$var$subscribers = new Set();
const $db92b1048ab2b69e$var$subscribe = (callback)=>{
    $db92b1048ab2b69e$var$subscribers.add(callback);
    return ()=>{
        $db92b1048ab2b69e$var$subscribers.delete(callback);
    };
};
const $db92b1048ab2b69e$var$skipSubscribe = ()=>()=>{};
const $db92b1048ab2b69e$var$getSkippedRememberedSource = ()=>undefined;
const $db92b1048ab2b69e$var$notifySubscribers = ()=>{
    $db92b1048ab2b69e$var$subscribers.forEach((callback)=>callback());
};
const $db92b1048ab2b69e$var$getSourceFromProvider = (provider)=>{
    const providerConfig = provider ? (0, $5qRqQ.SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS)[provider] : undefined;
    return provider && providerConfig ? {
        appName: providerConfig.displayName,
        provider: provider
    } : undefined;
};
const $db92b1048ab2b69e$var$getProviderFromContainerAri = (containerAri)=>{
    if (!containerAri) return undefined;
    const normalizedContainerAri = containerAri.toLowerCase();
    if (normalizedContainerAri.includes('microsoft.sharepoint') || normalizedContainerAri.includes(':sharepoint::')) return 'sharepoint';
    if (normalizedContainerAri.includes('microsoft.onedrive') || normalizedContainerAri.includes(':onedrive::')) return 'onedrive';
    if (normalizedContainerAri.includes('google.google-drive') || normalizedContainerAri.includes(':drive::')) return 'google-drive';
    return undefined;
};
const $db92b1048ab2b69e$var$getSourceFromContainerApp = (containerApp)=>$db92b1048ab2b69e$var$getSourceFromProvider(containerApp ? $db92b1048ab2b69e$var$providerByContainerApp[$db92b1048ab2b69e$var$normalizeProviderName(containerApp)] : undefined);
const $db92b1048ab2b69e$var$parseSmartFolderContentProperties = (propertyValue)=>{
    let parsedValue = propertyValue;
    try {
        for(let unwrapCount = 0; unwrapCount < 3; unwrapCount += 1){
            if (typeof parsedValue === 'string') {
                parsedValue = JSON.parse(parsedValue);
                continue;
            }
            if (typeof parsedValue !== 'object' || parsedValue === null) return undefined;
            const contentProperties = parsedValue;
            if (typeof contentProperties.value === 'string' || typeof contentProperties.value === 'object') {
                parsedValue = contentProperties.value;
                continue;
            }
            return contentProperties;
        }
    } catch  {
        return undefined;
    }
    return typeof parsedValue === 'object' && parsedValue !== null ? parsedValue : undefined;
};
const $db92b1048ab2b69e$var$getSourceFromPropertyValue = (propertyValue)=>{
    const parsedValue = $db92b1048ab2b69e$var$parseSmartFolderContentProperties(propertyValue);
    if (!parsedValue) return undefined;
    const containerApp = typeof parsedValue.containerApp === 'string' ? parsedValue.containerApp : typeof parsedValue.appName === 'string' ? parsedValue.appName : undefined;
    const sourceFromContainerApp = $db92b1048ab2b69e$var$getSourceFromContainerApp(containerApp);
    if (sourceFromContainerApp) return sourceFromContainerApp;
    const providerName = typeof parsedValue.provider === 'string' ? parsedValue.provider : undefined;
    const sourceFromProvider = $db92b1048ab2b69e$var$getSourceFromContainerApp(providerName);
    if (sourceFromProvider) return sourceFromProvider;
    const containerAri = typeof parsedValue.containerAri === 'string' ? parsedValue.containerAri : undefined;
    return $db92b1048ab2b69e$var$getSourceFromProvider($db92b1048ab2b69e$var$getProviderFromContainerAri(containerAri));
};
const $db92b1048ab2b69e$var$getSourceFromProperties = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $db92b1048ab2b69e$var$SMART_FOLDER_PROPERTIES_KEY);
    return smartFolderProperties?.value ? $db92b1048ab2b69e$var$getSourceFromPropertyValue(smartFolderProperties.value) : undefined;
};
const $db92b1048ab2b69e$export$1fe4bd7337433729 = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $db92b1048ab2b69e$var$SMART_FOLDER_PROPERTIES_KEY);
    return $db92b1048ab2b69e$var$parseSmartFolderContentProperties(smartFolderProperties?.value)?.paused === true;
};
const $db92b1048ab2b69e$export$91c2322e7dd18830 = ({ containerApp: containerApp, folderId: folderId })=>{
    const source = $db92b1048ab2b69e$var$getSourceFromContainerApp(containerApp);
    if (!source) return;
    $db92b1048ab2b69e$var$rememberedSources.set(folderId, source);
    $db92b1048ab2b69e$var$notifySubscribers();
};
const $db92b1048ab2b69e$export$e09566dabae6f841 = (properties)=>$db92b1048ab2b69e$var$getSourceFromProperties(properties) ?? {
        appName: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.displayName,
        provider: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.provider
    };
const $db92b1048ab2b69e$export$89fe473835f648f3 = (folderId, properties, options = {})=>{
    const { skip: skip = false } = options;
    const rememberedSource = (0, $cozmU.useSyncExternalStore)(skip ? $db92b1048ab2b69e$var$skipSubscribe : $db92b1048ab2b69e$var$subscribe, skip ? $db92b1048ab2b69e$var$getSkippedRememberedSource : ()=>$db92b1048ab2b69e$var$rememberedSources.get(folderId), $db92b1048ab2b69e$var$getSkippedRememberedSource);
    if (skip) return {
        appName: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.displayName,
        provider: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.provider
    };
    return $db92b1048ab2b69e$var$getSourceFromProperties(properties) ?? rememberedSource ?? {
        appName: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.displayName,
        provider: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.provider
    };
};
module.exports["getIsSmartFolderSyncPaused"] = $db92b1048ab2b69e$export$1fe4bd7337433729;
module.exports["rememberSmartFolderQuickActionSource"] = $db92b1048ab2b69e$export$91c2322e7dd18830;
module.exports["getSmartFolderQuickActionSource"] = $db92b1048ab2b69e$export$e09566dabae6f841;
module.exports["useSmartFolderQuickActionSource"] = $db92b1048ab2b69e$export$89fe473835f648f3;

});

parcelRegister("5qRqQ", function(module, exports) {

var $aMsxt = parcelRequire("aMsxt");


var $jX3NS = parcelRequire("jX3NS");


var $lp1F5 = parcelRequire("lp1F5");

const $f6a7ceb315be4336$export$13ea98513c50269a = [
    'google-drive',
    'sharepoint',
    'onedrive'
];
const $f6a7ceb315be4336$export$89232d171c71b6dd = {
    'google-drive': {
        provider: 'google-drive',
        displayName: 'Google Drive',
        fullConnectorName: 'google-drive-connector',
        connectorNames: [
            'google-drive-connector',
            'smartlinks-connector-gdrive',
            'smartlinks-connector-gdrive-rsl',
            'lite-connector-gdrive'
        ],
        Icon: (0, $aMsxt.GoogleDriveIcon)
    },
    sharepoint: {
        provider: 'sharepoint',
        displayName: 'SharePoint',
        fullConnectorName: 'sharepoint-connector',
        connectorNames: [
            'sharepoint-connector',
            'smartlinks-connector-sharepoint',
            'ai-3p-connector:sharepoint-domain'
        ],
        Icon: (0, $lp1F5.MicrosoftSharePointIcon)
    },
    onedrive: {
        provider: 'onedrive',
        displayName: 'OneDrive',
        fullConnectorName: 'onedrive-connector',
        connectorNames: [
            'smartlinks-connector-onedrive',
            'onedrive-connector'
        ],
        Icon: (0, $jX3NS.MicrosoftOneDriveIcon)
    }
};
module.exports["SMART_FOLDER_ROVO_CONNECTOR_PROVIDER_ORDER"] = $f6a7ceb315be4336$export$13ea98513c50269a;
module.exports["SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS"] = $f6a7ceb315be4336$export$89232d171c71b6dd;

});

parcelRegister("jX3NS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f19c4f9859fb5e6f14a1eb6fa1eee47>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $84256 = parcelRequire("84256");

const $bba93e208e351ca2$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#0364b8" d="M20.084 19.228v-.002l6.928 4.049 4.128-1.695a6.8 6.8 0 0 1 3.11-.518 10 10 0 0 0-3.017-4.913 10.4 10.4 0 0 0-5.274-2.512 10.55 10.55 0 0 0-5.825.703 10.25 10.25 0 0 0-4.49 3.69l.106-.003a8.36 8.36 0 0 1 4.334 1.2"/><path fill="#0078d4" d="M20.084 19.226v.002a8.36 8.36 0 0 0-4.334-1.2l-.106.002a8.4 8.4 0 0 0-4.237 1.204 8.1 8.1 0 0 0-2.995 3.163 7.88 7.88 0 0 0 .57 8.28l6.11-2.508 2.715-1.115 6.047-2.483 3.157-1.296z"/><path fill="#1490df" d="M34.25 21.063q-.224-.015-.453-.016a6.8 6.8 0 0 0-2.657.535l-4.128 1.694 1.197.7 3.924 2.292 1.712 1 5.853 3.422a6.4 6.4 0 0 0 .802-3.136 6.4 6.4 0 0 0-.835-3.127 6.6 6.6 0 0 0-2.268-2.355 6.8 6.8 0 0 0-3.148-1.009"/><path fill="#28a8ea" d="m33.844 27.27-1.712-1-3.923-2.293-1.197-.7-3.158 1.297-6.047 2.482-2.716 1.115-6.109 2.508a8.2 8.2 0 0 0 2.95 2.535 8.4 8.4 0 0 0 3.818.913h18.047a6.83 6.83 0 0 0 3.436-.924 6.6 6.6 0 0 0 2.465-2.512z"/></svg>';
function $bba93e208e351ca2$export$adf3a43722623322({ size: size, label: label = 'Microsoft OneDrive', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $84256.ThirdPartyLogoWrapper), {
        markup: $bba93e208e351ca2$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["MicrosoftOneDriveIcon"] = $bba93e208e351ca2$export$adf3a43722623322;

});

parcelRegister("3J7TU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $684d40bc929501f2$export$edb822e56299b4ef = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rCmOK",
    name: "CopyPageDialog",
    loader: async ()=>(await (parcelRequire("lmtT4"))).CopyPageDialogContainer
});
module.exports["CopyPageDialog"] = $684d40bc929501f2$export$edb822e56299b4ef;

});

parcelRegister("lmtT4", function(module, exports) {

let $f8d2d609f20f78f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f8d2d609f20f78f6$var$load("6wr18"),
    $f8d2d609f20f78f6$var$load("ffEVr"),
    $f8d2d609f20f78f6$var$load("kHXvF"),
    $f8d2d609f20f78f6$var$load("Wowvf"),
    $f8d2d609f20f78f6$var$load("hhss7"),
    $f8d2d609f20f78f6$var$load("aiU5r")
]).then(()=>parcelRequire('dVBJi'));

});

parcelRegister("78wUU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $745e4e253bb54f50$export$fbea3c6f057d30b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "epAoB",
    name: "MoveBlogModalLoader",
    loader: async ()=>(await (parcelRequire("5wbHN"))).MoveBlogModal
});
module.exports["MoveBlogModalLoader"] = $745e4e253bb54f50$export$fbea3c6f057d30b6;

});

parcelRegister("5wbHN", function(module, exports) {

let $4049055eafbc2e9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4049055eafbc2e9f$var$load("4izLy"),
    $4049055eafbc2e9f$var$load("6wr18"),
    $4049055eafbc2e9f$var$load("hBTro"),
    $4049055eafbc2e9f$var$load("4fYzp"),
    $4049055eafbc2e9f$var$load("ffEVr"),
    $4049055eafbc2e9f$var$load("Wowvf"),
    $4049055eafbc2e9f$var$load("hhss7"),
    $4049055eafbc2e9f$var$load("aoUod")
]).then(()=>parcelRequire('fzGQR'));

});

parcelRegister("iVd6X", function(module, exports) {
var $fd8faec801601310$export$6c1ad2d761708c0b = /*#__PURE__*/ function(PublishPageAsBlogSources) {
    PublishPageAsBlogSources["ViewPage"] = "VIEW_PAGE";
    PublishPageAsBlogSources["EditPage"] = "EDIT_PAGE";
    return PublishPageAsBlogSources;
}({});
module.exports["PublishPageAsBlogSources"] = $fd8faec801601310$export$6c1ad2d761708c0b;

});

parcelRegister("lu0E4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hXDOc = parcelRequire("hXDOc");


var $8G1o2 = parcelRequire("8G1o2");


var $dLX9a = parcelRequire("dLX9a");

const $d97c0945857481ee$export$8bc1bc0080a813ff = ({ isPublish: isPublish, contentId: contentId, spaceKey: spaceKey, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, children: children })=>{
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(contentId);
    const publishPreloadUrl = (0, $dLX9a.getPublishPreloadUrl)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    const closePreloadUrl = (0, $cozmU.useMemo)(()=>{
        if (!breadcrumbs || breadcrumbs.length === 0) return '';
        return (0, $dLX9a.getClosePreloadUrl)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            breadcrumbs: breadcrumbs,
            isUnpublishedDraft: isUnpublishedDraft
        });
    }, [
        contentId,
        spaceKey,
        contentType,
        isUnpublishedDraft,
        breadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
        name: "preload-button-wrapper",
        preloadUrl: isPublish ? publishPreloadUrl : closePreloadUrl,
        preloadOptions: (0, $hXDOc.PreloadingPresets).everything
    }, children);
};
module.exports["PreloadButtonWrapper"] = $d97c0945857481ee$export$8bc1bc0080a813ff;

});

parcelRegister("b66o6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f480656426be1312$export$b62abe642254f319 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "O8EvX",
    name: "RevertEditorDialog",
    loader: async ()=>(await (parcelRequire("kwhAi"))).RevertEditorDialog
});
module.exports["RevertEditorDialog"] = $f480656426be1312$export$b62abe642254f319;

});

parcelRegister("kwhAi", function(module, exports) {

let $ef046fb0196f7b22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef046fb0196f7b22$var$load("23MlT").then(()=>parcelRequire('1yiQ2'));

});

parcelRegister("BCkug", function(module, exports) {

var $9ieTK = parcelRequire("9ieTK");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $8aF6s = parcelRequire("8aF6s");


var $jv3O2 = parcelRequire("jv3O2");


var $ij4CE = parcelRequire("ij4CE");


var $bN5DJ = parcelRequire("bN5DJ");


var $3FmeR = parcelRequire("3FmeR");




const $f911f42fbae43711$export$652cb536b0ebabdb = (props)=>{
    const { contentId: contentId, spaceId: spaceId, isUnpublishedDraft: isUnpublishedDraft, analyticsSource: analyticsSource, adfOrigin: adfOrigin, onSuccessfulConversion: onSuccessfulConversion, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, flags: flags, saveDraft: saveDraft } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSuccess = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'convertedToLivePage',
                actionSubject: 'page',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        onSuccessfulConversion?.();
        showConvertToLivePageFlag({
            converterWasCurrentUser: true
        });
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        onSuccessfulConversion,
        showConvertToLivePageFlag
    ]);
    const writeSubTypeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $9ieTK.default),
        fragmentArtifact: (0, $9ieTK.default),
        __callerPackage__: "live-pages-features"
    });
    return (0, $cozmU.useCallback)(async ()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'switchToLiveEdit',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        if (!isUnpublishedDraft) showModal((0, $bN5DJ.ConvertToLivePageDialog), {
            contentId: contentId,
            onConfirm: onSuccess,
            adfOrigin: adfOrigin,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
        });
        else {
            // Trigger draft sync before converting. If we don't do this and the user recently updated their draft title then quickly converted the draft, draft sync may not have triggered and we may not identify their title conflict.
            await saveDraft?.();
            (0, $3FmeR.convertDraftToLivePage)({
                contentId: contentId,
                spaceId: spaceId,
                onSuccess: onSuccess,
                flags: flags,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                writeSubTypeFragment: writeSubTypeFragment
            });
        }
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        showModal,
        onSuccess,
        adfOrigin,
        retrieveEditorTitleAndContent,
        saveDraft,
        flags,
        writeSubTypeFragment
    ]);
};
module.exports["useSwitchToLivePage"] = $f911f42fbae43711$export$652cb536b0ebabdb;

});

parcelRegister("9ieTK", function(module, exports) {
/**
 * @generated SignedSource<<bf7406aa567fbba04e7cb02c4c87c8f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b5dcf221c9d66892$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSwitchToLivePageSubTypeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$b5dcf221c9d66892$var$node.hash = "83901263f96d64a150282b24a00afaf6";
var $b5dcf221c9d66892$export$2e2bcd8739ae039 = $b5dcf221c9d66892$var$node;
module.exports["default"] = $b5dcf221c9d66892$export$2e2bcd8739ae039;

});

parcelRegister("bN5DJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5b509ab565dd40fa$export$13f6b1ebaf0950f0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_DPHW",
    name: "ConvertToLivePageDialog",
    loader: async ()=>(await (parcelRequire("eZHuZ"))).ConvertToLivePageDialog
});
module.exports["ConvertToLivePageDialog"] = $5b509ab565dd40fa$export$13f6b1ebaf0950f0;

});

parcelRegister("eZHuZ", function(module, exports) {

let $aea8812b84cbe978$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aea8812b84cbe978$var$load("6wr18"),
    $aea8812b84cbe978$var$load("4fYzp"),
    $aea8812b84cbe978$var$load("ffEVr"),
    $aea8812b84cbe978$var$load("RU02s")
]).then(()=>parcelRequire('9Pjdf'));

});

parcelRegister("3FmeR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");


var $fyUox = parcelRequire("fyUox");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $6s78L = parcelRequire("6s78L");


var $9Yt7A = parcelRequire("9Yt7A");


var $6LFAK = parcelRequire("6LFAK");

const $cb12ca6e6f1d2ae2$var$i18nBase = (0, $kSwu1.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title",
        defaultMessage: "Unable to convert draft to live page"
    },
    genericErrorFlagTitle: {
        id: "live-pages-features.converttolivepage.generic-error.title",
        defaultMessage: "An error occurred"
    }
});
const $cb12ca6e6f1d2ae2$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title.livedocs",
        defaultMessage: "Unable to convert draft to live doc"
    }
});
const $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($cb12ca6e6f1d2ae2$var$i18nBase, $cb12ca6e6f1d2ae2$var$i18nLiveDocs);
const $cb12ca6e6f1d2ae2$var$preloadProperties = async (contentId, spaceId)=>{
    const tasks = [];
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: contentId,
        spaceKey: spaceId,
        fetchPolicy: 'network-only'
    }));
    tasks.push((0, $irrTO.preloadDraftContentAppearance)(contentId, false));
    return Promise.all(tasks);
};
const $cb12ca6e6f1d2ae2$export$a4275df84ffd8722 = async ({ contentId: contentId, spaceId: spaceId = '', onSuccess: onSuccess, flags: flags, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, writeSubTypeFragment: writeSubTypeFragment })=>{
    try {
        const { data: mutationData } = await (0, $6s78L.mutateInterop)({
            mutation: (0, $9Yt7A.default),
            variables: {
                contentId: contentId
            },
            update: (_, { data: data })=>{
                if (data?.convertPageToLiveEditAction?.success) {
                    writeSubTypeFragment({
                        fragmentId: `Content:${contentId}`,
                        data: {
                            __typename: 'Content',
                            subType: 'live'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            },
            __callerPackage__: "live-pages-features"
        });
        const result = mutationData?.convertPageToLiveEditAction;
        if (result?.success) {
            await $cb12ca6e6f1d2ae2$var$preloadProperties(contentId, spaceId).catch(()=>{
            // Since its a preload, we don't want show an error flag
            });
            onSuccess();
            return;
        }
        result?.errors?.forEach(async (error)=>{
            (0, $6LFAK.processError)(error, contentId);
            const flagTitle = error.message === 'Title already exists' ? $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.titleConflictFlagTitle : $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle;
            const flagDescription = (0, $6LFAK.getI18nStringForError)(error.message ?? '');
            const flagDescriptionValues = {};
            if (error.message === 'Title already exists') {
                const { title: pageTitle } = await retrieveEditorTitleAndContent();
                flagDescriptionValues.pageTitle = pageTitle || '';
            }
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), flagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...flagDescription,
                    values: flagDescriptionValues
                }),
                isAutoDismiss: false
            });
        });
    } catch (error) {
        (0, $6LFAK.processError)(error, contentId);
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6LFAK.i18n).unknownError),
            isAutoDismiss: false
        });
    }
};
const $cb12ca6e6f1d2ae2$export$5c2d46edf58b6daa = $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168;
module.exports["convertDraftToLivePage"] = $cb12ca6e6f1d2ae2$export$a4275df84ffd8722;

});

parcelRegister("9Yt7A", function(module, exports) {
/**
 * @generated SignedSource<<74425b153151e85569d7c520ffd47edb>>
 * @relayHash 603eb09fdbf7e41ae341d58b5067bb0a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4a98a70adb646dfa084b35cf854a7b68d474aa44e9927399f73da1aad0d0d1b
const $e053a44ee0757fb3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConvertPageToLiveEditActionPayload",
            "kind": "LinkedField",
            "name": "convertPageToLiveEditAction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertToLivePageMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertToLivePageMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "603eb09fdbf7e41ae341d58b5067bb0a",
            "id": "d4a98a70adb646dfa084b35cf854a7b68d474aa44e9927399f73da1aad0d0d1b",
            "metadata": {},
            "name": "ConvertToLivePageMutation",
            "operationKind": "mutation",
            "text": "mutation ConvertToLivePageMutation($contentId:ID!){convertPageToLiveEditAction(input:{contentId:$contentId}){success,errors{message}}}"
        }
    };
}();
$e053a44ee0757fb3$var$node.hash = "ad615689cf4fc4a255187ebb0a30c32e";
var $e053a44ee0757fb3$export$2e2bcd8739ae039 = $e053a44ee0757fb3$var$node;
module.exports["default"] = $e053a44ee0757fb3$export$2e2bcd8739ae039;

});

parcelRegister("6LFAK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $422HI = parcelRequire("422HI");


var $jhwJP = parcelRequire("jhwJP");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");


var $7Sm4c = parcelRequire("7Sm4c");

const $49d66c83bc63de25$var$i18nBase = (0, $kSwu1.defineMessages)({
    unknownError: {
        id: "live-pages-features.converttolivepage.modal.error.unknown",
        defaultMessage: "An error occurred. Please try again."
    },
    serverException: {
        id: "live-pages-features.converttolivepage.modal.error.serverException",
        defaultMessage: "An unexpected error occurred. Please try again later."
    },
    pageNotFound: {
        id: "live-pages-features.converttolivepage.modal.error.pageNotFound",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "The page you\u2019re trying to edit doesn\u2018t exist."
    },
    contentServiceException: {
        id: "live-pages-features.converttolivepage.modal.error.contentServiceException",
        defaultMessage: "The requested content is not available."
    },
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive",
        defaultMessage: "This page has already been switched to a live page."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError",
        defaultMessage: "This page can\u2019t be switched to a live page due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions",
        defaultMessage: "You don\u2019t have the necessary permissions to switch this to a live page."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    },
    viewScreenTitleConflict: {
        id: "live-pages-features.converttolivepage.modal.error.view-screen-conversion-title-conflict",
        defaultMessage: "There\u2019s already content with this page\u2019s updated title in the space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive.livedocs",
        defaultMessage: "This page has already been converted to a live doc."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError.livedocs",
        defaultMessage: "This page can\u2019t be converted to a live doc due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions.livedocs",
        defaultMessage: "You don\u2019t have the necessary permissions to convert this to a live doc."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description.livedocs",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($49d66c83bc63de25$var$i18nBase, $49d66c83bc63de25$var$i18nLiveDocs);
const $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY = {
    serverException: 'Some server exception',
    pageNotFound: 'Page not found with provided id',
    contentServiceException: 'Content service exception',
    pageAlreadyLive: 'Page subtype is already set to live',
    legacyPageConversionError: 'Legacy page cannot be converted to live edit',
    noEditPermissions: 'Page cannot be converted without edit permissions',
    draftTitleConflict: 'Title already exists'
};
const $49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE = Object.entries($49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY).reduce((acc, [key, value])=>({
        ...acc,
        [value]: key
    }), {});
const $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES = [
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.draftTitleConflict,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageAlreadyLive,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.noEditPermissions,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageNotFound
];
const $49d66c83bc63de25$export$55d2d97fdb72d6e6 = (errorMessage)=>{
    return $49d66c83bc63de25$export$a7357cdd1f0b0168[$49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE[errorMessage]] || $49d66c83bc63de25$export$a7357cdd1f0b0168.unknownError;
};
const $49d66c83bc63de25$export$ad03839ff2e809af = (error, contentId)=>{
    (0, $fJlJm.setContentErrorAttributes)(error, {
        objectId: contentId
    });
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    });
};
const $49d66c83bc63de25$export$83457a6c00af4df7 = (error, contentId)=>{
    let normalizedError;
    if (error instanceof Error || error instanceof (0, $422HI.ApolloErrorInterop)) normalizedError = error;
    else {
        // NOTE: Mutation errors from conversion have a null prototype, causing some below checks to throw an error because `hasOwnProperty` doesn't exist.
        //       Wrapping in a new Error retains original context and ensures the error contains `hasOwnProperty`, so we can handle the errors we're passed without issue.
        normalizedError = new Error(error?.message || 'Unknown error');
        if ('__typename' in error && error?.__typename) normalizedError.name = error?.__typename;
    }
    const isHandledConversionError = $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES.includes(normalizedError.message);
    if ((0, $1uFM6.isUnauthorizedError)(normalizedError) || (0, $6fil2.containsNetworkError)(normalizedError) || isHandledConversionError) {
        (0, $7Sm4c.markErrorAsHandled)(normalizedError);
        return {
            isHandled: true
        };
    } else {
        $49d66c83bc63de25$export$ad03839ff2e809af(normalizedError, contentId);
        return {
            isHandled: false
        };
    }
};
module.exports["i18n"] = $49d66c83bc63de25$export$a7357cdd1f0b0168;
module.exports["getI18nStringForError"] = $49d66c83bc63de25$export$55d2d97fdb72d6e6;
module.exports["processError"] = $49d66c83bc63de25$export$83457a6c00af4df7;

});

parcelRegister("9BVDK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02b364a2e855ad9d$export$20020b6b9f67a9ec = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "N5Ue8",
    name: "ResolvedInlineCommentsCounterLoader",
    loader: async ()=>(await (parcelRequire("1UGoe"))).ResolvedInlineCommentsCounter
});
module.exports["ResolvedInlineCommentsCounterLoader"] = $02b364a2e855ad9d$export$20020b6b9f67a9ec;

});

parcelRegister("1UGoe", function(module, exports) {

let $164be720e616bf86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $164be720e616bf86$var$load("aS96v").then(()=>parcelRequire('79cvA'));

});

parcelRegister("3oWMY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $goxV5 = parcelRequire("goxV5");


const $aac74fc16bd2f0e9$export$60620c3d63f5f30 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tETtx",
    name: "RendererPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("8ky1a"))).RendererPageCoverPicture;
    },
    loading: (0, $goxV5.RendererPageCoverPicturePlaceholder)
});
module.exports["RendererPageCoverPicture"] = $aac74fc16bd2f0e9$export$60620c3d63f5f30;

});

parcelRegister("goxV5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $jVylI = parcelRequire("jVylI");


var $75Ax4 = parcelRequire("75Ax4");

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/use-tokens-space, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766 */ const $be005db184746995$var$Placeholder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1DCdHiPgdg _0KLXruDMqu",
                __cmplp.isFixedWidthImageOption ? "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _313842LYhK _39xV02OAqP" : "_313842LYhK _39xV02rFfx _2XsHFM5ksT",
                __cmplp.smartSpaceOverviewHeight ? "_0jFU0Vm31q" : __cmplp.isFixedWidthImageOption ? "_0jFU0V6Tex" : "_0jFU0VurUm",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $be005db184746995$export$e9417b149b0db09d = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride, isSmartSpaceOverview: isSmartSpaceOverview } = t0;
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    let t1;
    if ($[0] !== appearance || $[1] !== hasCoverPicture || $[2] !== hasEmoji || $[3] !== isFixedWidthImageOption || $[4] !== isPagePreview || $[5] !== isSpaceOverview || $[6] !== smartSpaceOverviewHeight) {
        t1 = hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be005db184746995$var$Placeholder, {
            contentAppearance: appearance,
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            hasEmoji: hasEmoji,
            isFixedWidthImageOption: isFixedWidthImageOption
        })) : null;
        $[0] = appearance;
        $[1] = hasCoverPicture;
        $[2] = hasEmoji;
        $[3] = isFixedWidthImageOption;
        $[4] = isPagePreview;
        $[5] = isSpaceOverview;
        $[6] = smartSpaceOverviewHeight;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
module.exports["RendererPageCoverPicturePlaceholder"] = $be005db184746995$export$e9417b149b0db09d;

});

parcelRegister("8ky1a", function(module, exports) {

let $610a9436eb4bad9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $610a9436eb4bad9e$var$load("6T9n5"),
    $610a9436eb4bad9e$var$load("c9e1W"),
    $610a9436eb4bad9e$var$load("bfTdl"),
    $610a9436eb4bad9e$var$load("2cSY3"),
    $610a9436eb4bad9e$var$load("vsgOr"),
    $610a9436eb4bad9e$var$load("i313S"),
    $610a9436eb4bad9e$var$load("6OMo6"),
    $610a9436eb4bad9e$var$load("aaRXj"),
    $610a9436eb4bad9e$var$load("fHlIz"),
    $610a9436eb4bad9e$var$load("4QwAJ"),
    $610a9436eb4bad9e$var$load("3i44s"),
    $610a9436eb4bad9e$var$load("5kI0b"),
    $610a9436eb4bad9e$var$load("kYkz1"),
    $610a9436eb4bad9e$var$load("jfYeU"),
    $610a9436eb4bad9e$var$load("b4nm1"),
    $610a9436eb4bad9e$var$load("geXPZ"),
    $610a9436eb4bad9e$var$load("aQ5uu"),
    $610a9436eb4bad9e$var$load("cByHu"),
    $610a9436eb4bad9e$var$load("1oKjW"),
    $610a9436eb4bad9e$var$load("excC5"),
    $610a9436eb4bad9e$var$load("kGmwI"),
    $610a9436eb4bad9e$var$load("aAWLw"),
    $610a9436eb4bad9e$var$load("4Bg7q")
]).then(()=>parcelRequire('9ChZM'));

});

parcelRegister("5nr5P", function(module, exports) {

var $kNIYN = parcelRequire("kNIYN");

class $22dbf97de39b4a94$export$8428b29fbe35d5c extends (0, $kNIYN.Container) {
    constructor({ loadUuid: loadUuid = '', contentId: contentId = null, userCanEditRestrictions: userCanEditRestrictions = false, currentUserInfo: currentUserInfo = null, hasInheritedRestrictions: hasInheritedRestrictions = false, hasRestrictions: hasRestrictions = false, isLoaded: isLoaded = false, restrictionsDetails: restrictionsDetails = null, spaceKey: spaceKey = null, spaceContainsExternalCollaborators: spaceContainsExternalCollaborators = false, externalCollaboratorCount: externalCollaboratorCount = 0, operations: operations = null, contentTitle: contentTitle = null, edition: edition = null, isSiteAdmin: isSiteAdmin = false, contentType: contentType = null, contentSubType: contentSubType = null, isExternalShareEnabledForSite: isExternalShareEnabledForSite = false, isPageExternallyShared: isPageExternallyShared = false, isExternalShareVariation: isExternalShareVariation = false, isContentExternallySharable: isContentExternallySharable = false, canEditPublicLink: canEditPublicLink = false, ancestors: ancestors = [] } = {}){
        super();
        this.getData = ()=>{
            return this.state;
        };
        this.resetData = ()=>{
            this.setState({
                loadUuid: '',
                contentId: null,
                contentPermissions: null,
                currentUserInfo: null,
                hasInheritedRestrictions: false,
                hasRestrictions: false,
                isLoaded: false,
                restrictionsDetails: null,
                spaceKey: null,
                spaceContainsExternalCollaborators: false,
                externalCollaboratorCount: 0,
                operations: null,
                contentTitle: null,
                edition: null,
                isSiteAdmin: false,
                contentType: null,
                contentSubType: null,
                contentStatus: undefined,
                isExternalShareEnabledForSite: false,
                isPageExternallyShared: false,
                isExternalShareVariation: false,
                isContentExternallySharable: false,
                canEditPublicLink: false,
                ancestors: []
            });
        };
        this.setData = (data)=>{
            if (Object.keys(data).some((k)=>data[k] !== this.state[k])) this.setState(data);
        };
        this.getIsLoaded = ()=>{
            return this.state.isLoaded;
        };
        this.getContentId = ()=>{
            return this.state.contentId;
        };
        this.getLoadUuid = ()=>{
            return this.state.loadUuid;
        };
        this.state = {
            loadUuid: loadUuid,
            contentId: contentId,
            userCanEditRestrictions: userCanEditRestrictions,
            currentUserInfo: //   currentUserInfo: PropTypes.shape({
            //     id: PropTypes.string.isRequired,
            //     displayName: PropTypes.string.isRequired,
            //     isSuperAdmin: PropTypes.bool,
            //     profilePicture: PropTypes.shape({
            //       path: PropTypes.string
            //     })
            //   }).isRequired,
            currentUserInfo,
            hasInheritedRestrictions: hasInheritedRestrictions,
            hasRestrictions: hasRestrictions,
            isLoaded: isLoaded,
            restrictionsDetails: // const restrictionsShape = {
            //   restrictions: PropTypes.shape({
            //     user: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           accountId: PropTypes.string,
            //           displayName: PropTypes.string,
            //           type: PropTypes.string
            //         })
            //       )
            //     }),
            //     group: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           name: PropTypes.string
            //         })
            //       )
            //     })
            //   })
            // };
            restrictionsDetails,
            spaceKey: spaceKey,
            spaceContainsExternalCollaborators: spaceContainsExternalCollaborators,
            externalCollaboratorCount: externalCollaboratorCount,
            operations: operations,
            contentTitle: contentTitle,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            contentType: contentType,
            contentSubType: contentSubType,
            isExternalShareEnabledForSite: isExternalShareEnabledForSite,
            isPageExternallyShared: isPageExternallyShared,
            isExternalShareVariation: isExternalShareVariation,
            isContentExternallySharable: isContentExternallySharable,
            canEditPublicLink: canEditPublicLink,
            ancestors: ancestors
        };
    }
}
module.exports["RestrictionsDataContainer"] = $22dbf97de39b4a94$export$8428b29fbe35d5c;

});

parcelRegister("lyx2E", function(module, exports) {
/* contentTypesHeaderStyles.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $w6R6I = parcelRequire("w6R6I");


var $3izAL = parcelRequire("3izAL");

const $3d1681a377877e6e$export$e139d3b51c488e9b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFloating: isFloating, hasPointerEvents: hasPointerEvents, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fwhixl": (0, $9aYkv.default)((()=>{
                return __cmplp.isFloating ? 'absolute' : 'relative';
            })()),
            "--_17xabpo": (0, $9aYkv.default)((()=>{
                return __cmplp.hasPointerEvents ? 'auto' : 'none';
            })())
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0KLXrujOvk _1mT5xd1EEW _1pp6NdHETu _39xV02N91d _3iDTPbgBM8",
            __cmplp.className
        ])
    });
});
const $3d1681a377877e6e$var$styles = {
    base: "_0bjKvDKxmn _2Y7lL42ADO _1pp6NdIZbP _0KLXrulfZc _0xmtko1Y8M _3iDTPbQ4SZ _3TGfC9LRg7 _46hvQm1Y8M _0jFU0VN91d",
    alignCenter: "_4xdlr0DIqT"
};
const $3d1681a377877e6e$export$b1249ef660098484 = ({ isContentHeaderPinned: isContentHeaderPinned = false, xcss: xcss, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: (0, $w6R6I.cx)($3d1681a377877e6e$var$styles.base, isContentHeaderPinned && $3d1681a377877e6e$var$styles.alignCenter, xcss)
    }, children);
};
module.exports["ContentTypesHeaderContainer"] = $3d1681a377877e6e$export$e139d3b51c488e9b;
module.exports["TitleAndBreadcrumbsWrapper"] = $3d1681a377877e6e$export$b1249ef660098484;

});

parcelRegister("deZfn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3af5d746447ab7ac$export$a32ab742d345a2c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "u0VI7",
    name: "ArchivedPageBanner",
    loader: async ()=>(await (parcelRequire("5ZyCZ"))).ArchivedPageBanner
});
module.exports["ArchivedPageBanner"] = $3af5d746447ab7ac$export$a32ab742d345a2c9;

});

parcelRegister("5ZyCZ", function(module, exports) {

let $45cd829fc48bdef7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45cd829fc48bdef7$var$load("6rpul").then(()=>parcelRequire('2ZkUh'));

});

parcelRegister("8z0fF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $kC9tB = parcelRequire("kC9tB");


const $fcf77a474368dc3c$export$2626335f65c6c2ab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GPirm",
    name: "EmojiTitleSelection",
    loader: async ()=>(await (parcelRequire("29uGU"))).EmojiTitleSelection,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kC9tB.EmojiTitleSelectionPlaceholder), props)
});
module.exports["EmojiTitleSelection"] = $fcf77a474368dc3c$export$2626335f65c6c2ab;

});

parcelRegister("kC9tB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $crLHf = parcelRequire("crLHf");

// Altogether, the container width should be equivalent to the width of EmojiTitleSelection once loaded
const $12207dce16c7aead$var$paddingStyle = (0, $buxP3.xcss)({
    paddingRight: 'space.150',
    // this is the spacing between the emoji button and the title
    paddingLeft: 'space.050' // necessary for left aligning placeholder with emoji button (value comes from from button base)
});
const $12207dce16c7aead$export$f477b16652398d6f = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { hasInitialEmoji: hasInitialEmoji, hasCoverPicture: hasCoverPicture, isTitleCenterAligned: isTitleCenterAligned } = t0;
    const needsPadding = !hasCoverPicture && !isTitleCenterAligned;
    let t1;
    if ($[0] !== hasCoverPicture || $[1] !== hasInitialEmoji || $[2] !== needsPadding) {
        t1 = hasInitialEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: needsPadding ? $12207dce16c7aead$var$paddingStyle : null,
            testId: "emoji-selection-placeholder-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: hasCoverPicture ? 80 : 40
        })) : null;
        $[0] = hasCoverPicture;
        $[1] = hasInitialEmoji;
        $[2] = needsPadding;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["EmojiTitleSelectionPlaceholder"] = $12207dce16c7aead$export$f477b16652398d6f;

});

parcelRegister("29uGU", function(module, exports) {

let $19143aa1840df76e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $19143aa1840df76e$var$load("dPFEi"),
    $19143aa1840df76e$var$load("dlm6q"),
    $19143aa1840df76e$var$load("bQbUW"),
    $19143aa1840df76e$var$load("bfTdl"),
    $19143aa1840df76e$var$load("2cSY3"),
    $19143aa1840df76e$var$load("vsgOr"),
    $19143aa1840df76e$var$load("i313S"),
    $19143aa1840df76e$var$load("6wr18"),
    $19143aa1840df76e$var$load("ffEVr"),
    $19143aa1840df76e$var$load("4izLy"),
    $19143aa1840df76e$var$load("9vN6N"),
    $19143aa1840df76e$var$load("29WXq"),
    $19143aa1840df76e$var$load("953Uz"),
    $19143aa1840df76e$var$load("6KGrg"),
    $19143aa1840df76e$var$load("4hZJd")
]).then(()=>parcelRequire('leLdu'));

});

parcelRegister("5qUgM", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $gw4Bt = parcelRequire("gw4Bt");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("9VtwR", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $7Y8M5 = parcelRequire("7Y8M5");


var $6e6qw = parcelRequire("6e6qw");

const $6bda54ffb0f4283a$var$presencePrefix = '/ncs-presence';
const $6bda54ffb0f4283a$export$2fbd87a2176aa7cf = (id)=>{
    if (!id) return (0, $7Y8M5.participantColors)[0];
    return (0, $6e6qw.getParticipantColor)(id).color;
};
const $6bda54ffb0f4283a$export$fecb54e21647ae4f = ()=>{
    return {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    };
};
const $6bda54ffb0f4283a$export$a8078789f7ade13a = (participants, sessionId)=>{
    if (sessionId) return [
        ...participants.values()
    ].find((p)=>p.sessions[sessionId]);
};
const $6bda54ffb0f4283a$export$8c4801f1df434a3 = (sessionData, currentUserSessionId, defaultActivity)=>{
    if (currentUserSessionId) return sessionData[currentUserSessionId]?.activity ?? defaultActivity ?? 'viewer';
    else {
        const hasEditor = Object.keys(sessionData).find((sessionId)=>sessionData[sessionId]?.activity === 'editor');
        return hasEditor ? 'editor' : 'viewer';
    }
};
const $6bda54ffb0f4283a$export$cd367e77e21c7f3d = ()=>{
    const route = 'collab-presence-confluence';
    if (window.location.hostname === 'localhost' && true) {
        const host = window.__backendOriginHost;
        return `https://${host}/${route}`;
    }
    return `${window.location.origin}/${route}`;
};
const $6bda54ffb0f4283a$export$324e5039614a122a = (cloudId, activationId)=>{
    return `${$6bda54ffb0f4283a$var$presencePrefix}/${cloudId}/${activationId}/confluence`;
};
const $6bda54ffb0f4283a$var$presenceCanvasContentTypes = [
    'database',
    'whiteboard',
    'slide'
];
const $6bda54ffb0f4283a$export$ea7ca1acbbc07168 = (contentType)=>$6bda54ffb0f4283a$var$presenceCanvasContentTypes.includes(contentType);
const $6bda54ffb0f4283a$export$73e42e5abf6898ab = ()=>`presence-${(0, $9HkI0.v4)()}`;
const $6bda54ffb0f4283a$export$dd4b75f1a6268a6b = 4;
const $6bda54ffb0f4283a$export$a9b806721f7a3927 = 'dummy-session-id';
const $6bda54ffb0f4283a$export$72a96dbd0b162542 = 'unidentified';
module.exports["getParticipantColors"] = $6bda54ffb0f4283a$export$2fbd87a2176aa7cf;
module.exports["getCurrentUserColors"] = $6bda54ffb0f4283a$export$fecb54e21647ae4f;
module.exports["getCurrentUserFromMap"] = $6bda54ffb0f4283a$export$a8078789f7ade13a;
module.exports["getActivityToDisplay"] = $6bda54ffb0f4283a$export$8c4801f1df434a3;
module.exports["getPresenceServiceUrl"] = $6bda54ffb0f4283a$export$cd367e77e21c7f3d;
module.exports["getPresenceServicePath"] = $6bda54ffb0f4283a$export$324e5039614a122a;
module.exports["isCanvasContentType"] = $6bda54ffb0f4283a$export$ea7ca1acbbc07168;
module.exports["getPresenceClientId"] = $6bda54ffb0f4283a$export$73e42e5abf6898ab;
module.exports["MAX_GROUP_SIZE"] = $6bda54ffb0f4283a$export$dd4b75f1a6268a6b;
module.exports["CURRENT_USER_DUMMY_SESSION_ID"] = $6bda54ffb0f4283a$export$a9b806721f7a3927;
module.exports["UNIDENTIFIED"] = $6bda54ffb0f4283a$export$72a96dbd0b162542;

});

parcelRegister("pskhd", function(module, exports) {
const $b218ab7927acda99$export$169d32883304392c = (data)=>{
    const isCurrentUserWatching = data?.singleContent?.currentUserIsWatching ?? false;
    const isWatchingSpace = data?.singleContent?.space?.currentUser?.isWatched ?? false;
    const isWatchingBlogs = data?.singleContent?.space?.currentUser?.isWatchingBlogs ?? false;
    // TODO remove type checks once watch with children gate cleaned up
    const isWatchingChildren = data?.singleContent && 'currentUserIsWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserIsWatchingChildren ?? false : false;
    const hasAncestorWatchingChildren = data?.singleContent && 'currentUserHasAncestorWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserHasAncestorWatchingChildren ?? false : false;
    return {
        isCurrentUserWatching: isCurrentUserWatching,
        isWatchingSpace: isWatchingSpace,
        isWatchingBlogs: isWatchingBlogs,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren
    };
};
module.exports["processWatchData"] = $b218ab7927acda99$export$169d32883304392c;

});

parcelRegister("kPqqM", function(module, exports) {

var $SF9MR = parcelRequire("SF9MR");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9d7Pd = parcelRequire("9d7Pd");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $cf6nm = parcelRequire("cf6nm");


var $iCPvv = parcelRequire("iCPvv");


var $jMyy4 = parcelRequire("jMyy4");

const $3dca15cc31736255$export$f4601f3807dd9177 = ({ isDisabled: isDisabled, className: className, shortcut: shortcut, ...props })=>{
    const TooltipI18n = props.isStarred ? $3dca15cc31736255$var$i18n.Unstar : $3dca15cc31736255$var$i18n.Star;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iCPvv.SpaceStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            testId: "star-menu-item",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: className,
            isDisabled: isDisabled,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf6nm.StarIcon), {
                isStarred: props.isStarred,
                spacing: props.spacing
            }),
            onClick: toggleStar,
            iconAfter: shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: shortcut
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), TooltipI18n)));
};
const $3dca15cc31736255$export$e07e4133bf676bf6 = ({ spaceKey: spaceKey })=>{
    const { data: spaceFavouriteStatusData } = (0, $jMyy4.useQueryInterop)((0, $SF9MR.default), {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "action-buttons"
    });
    const isStarred = spaceFavouriteStatusData?.space?.currentUser?.isFavourited || false;
    const spaceName = spaceFavouriteStatusData?.space?.name || spaceFavouriteStatusData?.space?.alias || spaceFavouriteStatusData?.space?.key || '';
    const spaceId = spaceFavouriteStatusData?.space?.id || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dca15cc31736255$export$f4601f3807dd9177, {
        isStarred: isStarred,
        spaceId: spaceId,
        spaceKey: spaceKey,
        spacing: "none",
        spaceName: spaceName,
        shortcut: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
        shouldShowFlags: true,
        analytics: {
            attributes: {
                isContentWrapper: true,
                spaceId: // as of now, SpaceStarMenuItemWithQuery is only called from object header overflow menu
                spaceId
            },
            source: 'SpaceStarMenuItemOverflowMenu'
        }
    });
};
const $3dca15cc31736255$var$i18n = (0, $kSwu1.defineMessages)({
    Star: {
        id: "action-buttons.space.star.menu.item",
        defaultMessage: "Star space"
    },
    Unstar: {
        id: "action-buttons.space.unstar.menu.item",
        defaultMessage: "Unstar space"
    }
});
module.exports["SpaceStarMenuItem"] = $3dca15cc31736255$export$f4601f3807dd9177;
module.exports["SpaceStarMenuItemWithQuery"] = $3dca15cc31736255$export$e07e4133bf676bf6;

});

parcelRegister("SF9MR", function(module, exports) {
/**
 * @generated SignedSource<<6c76fed1cd91ee9b7df046b7fa9db63a>>
 * @relayHash 559bd430fdfdfbcc11a49c9267441232
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872
const $00b16c2e2c56a4ba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "559bd430fdfdfbcc11a49c9267441232",
            "id": "81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872",
            "metadata": {},
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "operationKind": "query",
            "text": "query SpaceStarMenuItemIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id,alias,name,key,currentUser{isFavourited}}}"
        }
    };
}();
$00b16c2e2c56a4ba$var$node.hash = "c77a49dbb962e7ad6bf61d5e4f25b221";
var $00b16c2e2c56a4ba$export$2e2bcd8739ae039 = $00b16c2e2c56a4ba$var$node;
module.exports["default"] = $00b16c2e2c56a4ba$export$2e2bcd8739ae039;

});

parcelRegister("iCPvv", function(module, exports) {

var $h4SYW = parcelRequire("h4SYW");


var $3rcpI = parcelRequire("3rcpI");


var $8DAzB = parcelRequire("8DAzB");


var $iWaZt = parcelRequire("iWaZt");


var $eUlFW = parcelRequire("eUlFW");


var $5j9jt = parcelRequire("5j9jt");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $cTJK3 = parcelRequire("cTJK3");


var $7aRa9 = parcelRequire("7aRa9");


var $308Wd = parcelRequire("308Wd");


var $cfidN = parcelRequire("cfidN");







const $ac59452c65a90798$var$i18n = (0, $kSwu1.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.space.star.error.title",
        defaultMessage: "We\u2019re having trouble starring this space"
    },
    unstarErrorTitle: {
        id: "action-buttons.space.unstar.error.title",
        defaultMessage: "We\u2019re having trouble unstarring this space"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh and try again."
    },
    starSuccessFlagTitle: {
        id: "action-buttons.space.star.success.title",
        defaultMessage: "{spaceName} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.space.unstar.success.title",
        defaultMessage: "{spaceName} unstarred"
    }
});
const $ac59452c65a90798$var$SpaceStarComponent = ({ spaceId: spaceId, spaceKey: spaceKey, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, spaceName: spaceName, shouldShowFlags: shouldShowFlags })=>{
    const readCurrentSpace = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5j9jt.default),
        __callerPackage__: "action-buttons"
    });
    const readStarredSpaces = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $eUlFW.default),
        __callerPackage__: "action-buttons"
    });
    const writeUpdateCurrentUserFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $iWaZt.default),
        fragmentArtifact: (0, $iWaZt.default),
        __callerPackage__: "action-buttons"
    });
    const writeStarredSpacesFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $8DAzB.default),
        fragmentArtifact: (0, $8DAzB.default),
        __callerPackage__: "action-buttons"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const modifyStarCache = (0, $cozmU.useCallback)((newStarredValue)=>{
        try {
            // The (Un)FavoriteSpaceMutations do not return the updated space, so we need to manually update the cache.
            // This is necessary to update the UI immediately after the user clicks the star button.
            writeUpdateCurrentUserFragment({
                fragmentId: `Space:${spaceId}`,
                data: {
                    currentUser: {
                        isFavourited: newStarredValue,
                        __typename: 'SpaceUserMetadata'
                    },
                    __typename: 'Space'
                }
            });
            // Update the starred spaces list in the Spaces dropdown (and any other consumers of useSpacesData)
            (0, $cTJK3.updateStarredSpacesList)(spaceId, newStarredValue, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment);
        } catch  {}
    }, [
        spaceId,
        readCurrentSpace,
        readStarredSpaces,
        writeStarredSpacesFragment,
        writeUpdateCurrentUserFragment
    ]);
    const [starSpace, { error: starError }] = (0, $308Wd.useMutationInterop)((0, $3rcpI.default), {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(false);
        },
        __callerPackage__: "action-buttons"
    });
    const [unstarSpace, { error: unstarError }] = (0, $308Wd.useMutationInterop)((0, $h4SYW.default), {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(true);
        },
        __callerPackage__: "action-buttons"
    });
    const toggleStar = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) onUnstar && onUnstar(e);
        else onStar && onStar(e);
        // Optimistically update the cache
        modifyStarCache(!isStarred);
        const mutation = isStarred ? unstarSpace : starSpace;
        mutation({
            variables: {
                spaceKey: spaceKey
            }
        }).then(()=>{
            if (isStarred && shouldShowFlags) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
            else if (!isStarred && shouldShowFlags) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.starSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
        }).catch((_)=>{});
        if (analytics) {
            const { source: source, containerId: containerId, attributes: attributes } = analytics;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: isStarred ? 'unstarred' : 'starred',
                    actionSubject: 'space',
                    source: source,
                    attributes: attributes,
                    ...containerId && {
                        containerId: containerId
                    }
                }
            }).fire();
        }
    }, [
        isStarred,
        spaceKey,
        analytics,
        starSpace,
        unstarSpace,
        modifyStarCache,
        onStar,
        onUnstar,
        createAnalyticsEvent,
        flags,
        intl,
        spaceName,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.starErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $ac59452c65a90798$export$4e2eb132a04ae560 = (0, $7aRa9.withFlags)((0, $kSwu1.injectIntl)($ac59452c65a90798$var$SpaceStarComponent));
module.exports["SpaceStar"] = $ac59452c65a90798$export$4e2eb132a04ae560;

});

parcelRegister("h4SYW", function(module, exports) {
/**
 * @generated SignedSource<<c9db3185ab8693debf04c06c2635c98e>>
 * @relayHash 9713a87882c5e6383e438ee687952963
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495
const $1e902e1ae2e520ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "FavouriteSpacePayload",
            "kind": "LinkedField",
            "name": "unfavouriteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isSpaceFavourited"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9713a87882c5e6383e438ee687952963",
            "id": "24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495",
            "metadata": {},
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceStarUnfavoriteSpaceMutation($spaceKey:String!){unfavouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
        }
    };
}();
$1e902e1ae2e520ea$var$node.hash = "947f8794b11432ca2dea89537ba4c2d6";
var $1e902e1ae2e520ea$export$2e2bcd8739ae039 = $1e902e1ae2e520ea$var$node;
module.exports["default"] = $1e902e1ae2e520ea$export$2e2bcd8739ae039;

});

parcelRegister("3rcpI", function(module, exports) {
/**
 * @generated SignedSource<<fa08bda29fced98f3c45302e6ced8426>>
 * @relayHash 74b417d304c57976b899306f93428c4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647
const $55e292c0c31a2a67$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "FavouriteSpacePayload",
            "kind": "LinkedField",
            "name": "favouriteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isSpaceFavourited"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarFavoriteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarFavoriteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74b417d304c57976b899306f93428c4f",
            "id": "b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647",
            "metadata": {},
            "name": "SpaceStarFavoriteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceStarFavoriteSpaceMutation($spaceKey:String!){favouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
        }
    };
}();
$55e292c0c31a2a67$var$node.hash = "9ac5c6d950db28ef929151bfa7f1b419";
var $55e292c0c31a2a67$export$2e2bcd8739ae039 = $55e292c0c31a2a67$var$node;
module.exports["default"] = $55e292c0c31a2a67$export$2e2bcd8739ae039;

});

parcelRegister("8DAzB", function(module, exports) {
/**
 * @generated SignedSource<<39f18a245a31c007c77ce5f5c9ee8f94>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $edf1f89db5626c55$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarWriteStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$edf1f89db5626c55$var$node.hash = "72f0ab1980fee3d3ebcdbd9647ddc161";
var $edf1f89db5626c55$export$2e2bcd8739ae039 = $edf1f89db5626c55$var$node;
module.exports["default"] = $edf1f89db5626c55$export$2e2bcd8739ae039;

});

parcelRegister("iWaZt", function(module, exports) {
/**
 * @generated SignedSource<<96b0d47a239a4453b03d10a247c9e028>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3dd5c0573ac0253a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarActionButtonSpaceFragment",
    "selections": [
        {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourited"
                }
            ]
        }
    ],
    "type": "Space"
};
$3dd5c0573ac0253a$var$node.hash = "8952ed3b4f2eb093d58223c1da19fdac";
var $3dd5c0573ac0253a$export$2e2bcd8739ae039 = $3dd5c0573ac0253a$var$node;
module.exports["default"] = $3dd5c0573ac0253a$export$2e2bcd8739ae039;

});

parcelRegister("eUlFW", function(module, exports) {
/**
 * @generated SignedSource<<0b51e0ed63eacdac2772293ea5508c48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ae9f5e7e7a9dde99$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarReadStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$ae9f5e7e7a9dde99$var$node.hash = "4a38c9f3868a7bbf44a9931e1d6903ac";
var $ae9f5e7e7a9dde99$export$2e2bcd8739ae039 = $ae9f5e7e7a9dde99$var$node;
module.exports["default"] = $ae9f5e7e7a9dde99$export$2e2bcd8739ae039;

});

parcelRegister("5j9jt", function(module, exports) {
/**
 * @generated SignedSource<<d686b0eedf9323798b549af0da2f0f71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b485608b483d3bf6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarCurrentSpaceFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "alias"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "path"
                }
            ]
        }
    ],
    "type": "Space"
};
$b485608b483d3bf6$var$node.hash = "0e7af2ea53ea33a3d76e321d036b891d";
var $b485608b483d3bf6$export$2e2bcd8739ae039 = $b485608b483d3bf6$var$node;
module.exports["default"] = $b485608b483d3bf6$export$2e2bcd8739ae039;

});

parcelRegister("cTJK3", function(module, exports) {
const $a85b49bec4fd02db$export$1c070079c48d3bdd = (spaceId, isStarred, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment)=>{
    const space = readCurrentSpace({
        id: `Space:${spaceId}`
    });
    try {
        const starredSpaces = readStarredSpaces({
            id: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`
        })?.nodes || [];
        let newStarredSpaces;
        if (isStarred) {
            newStarredSpaces = [
                ...starredSpaces,
                space
            ];
            newStarredSpaces.sort((a, b)=>!a?.name || !b?.name ? 0 : a.name.localeCompare(b.name));
        } else newStarredSpaces = starredSpaces.filter((s)=>s?.id !== spaceId);
        writeStarredSpacesFragment({
            fragmentId: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`,
            data: {
                nodes: newStarredSpaces,
                __typename: 'PaginatedSpaceList'
            }
        });
    } catch  {
    // If Apollo throws an error, the starred spaces data was not found in the cache.
    // Errors can be safely ignored as if there is no cache entry, there is no work to be done.
    }
};
module.exports["updateStarredSpacesList"] = $a85b49bec4fd02db$export$1c070079c48d3bdd;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("8w1c1", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("aWrnw", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});


//# sourceMappingURL=NativeCollabComponent.b81adabe.js.map
